/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'خطأ داخلي',
      not_allowed: 'الإجراء غير مسموح به',
      access_denied: 'تم رفض الوصول',
      validator_error: 'خطأ في الصحة {details}',
      wrong_body: 'نص خاطئ',
      wrong_token: 'رمز خاطئ',
      missing_token: 'الرمز المفقود',
      exclusive_lock: 'قفل حصري',
      access_denied_acl: 'تم رفض الوصول (ACL)',
      connection_timeout: 'انتهت مهلة الاتصال',
      login_required: 'تسجيل الدخول مطلوب',
      not_found: 'لم يتم العثور عليه',
      wrong_value: 'قيمة خاطئة',
      token_expired: 'الرمز منتهي الصلاحية',
      service_not_available: 'الخدمة غير متاحة',
      twofa_required: 'المصادقة المطلوبة 2FA',
      missing_login_token: 'تسجيل الدخول مطلوب',
    },
    account: {
      banned: 'حظر حسابك',
      wrong_login_or_password: 'تسجيل الدخول أو كلمة المرور الخطأ',
      wrong_login: 'خطأ في تسجيل الدخول ',
      wrong_password: 'كلمة مرور خاطئة',
      blocked: 'حظر حسابي',
      missing_email: 'عنوان البريد الإلكتروني غير مخصص',
      same_password_used: 'نفس كلمة المرور تم استخدامها',
      apikey_not_created: 'مفتاح API لم يتم إنشاؤه',
      apikey_already_created: 'تم إنشاء مفتاح API بالفعل',
      twofa_not_created: '2FA لم يتم إنشاؤه',
      twofa_already_created: '2FA تم إنشاؤها بالفعل',
      deletion_already_started: 'بدأت عملية حذف الحساب بالفعل',
      wrong_twofa: 'رمز 2FA خاطئ',
      external_withdraw_not_available: 'السحب الخارجي غير متاح',
      twofa_limit: '2FA محدود',
      kyc_wrong_step: 'KYC خطوة خاطئة',
      not_exists: 'لا يوجد',
      kyc_required: 'KYC مطلوب',
      action_not_allowed: 'الإجراء غير مسموح به',
      migration: 'هجرة',
      wrong_password_pattern: 'كلمة المرور يجب أن تحتوي على 8 إلى 64 حرفًا وعلى الأقل حرف كبير وحرف صغير ورقم وحرف خاص',
    },
    market: {
      not_enough_funds: 'لا يوجد ما يكفي من الأموال',
      missing_steam_token: 'رابط تداول Steam مفقود',
      missing_steam_id: 'معرف ستيم المفقود',
      wrong_item_status: 'حالة العنصر خاطئة',
      item_already_queued: 'العنصر موجود بالفعل في قائمة الانتظار',
      max_price_limit: 'حد السعر الأقصى',
      item_not_available: 'العنصر غير متوفر',
      steam_vac_ban: 'حظر Steam VAC',
      steam_trade_ban: 'حظر التداول في Steam',
      steam_private_profile: 'الملف الشخصي الخاص Steam',
      steam_private_inventory: 'المخزون الخاص Steam',
      steam_tradehold: 'تعليق التداول على Steam',
      cannot_check_tradeban: 'لا يمكن التحقق من حظر التداول',
      cannot_check_tradehold: 'لا يمكن التحقق من تعليق التداول',
      wrong_steam_token: 'خطأ في رمز ستيم',
      no_items_found: 'لم يتم العثور على العناصر',
      items_limit: 'الحد الأقصى للعناصر',
      instant_sell_disabled: 'تم تعطيل البيع الفوري',
      plan_not_found: 'خطة غير موجودة',
      price_too_low: 'السعر منخفض جدا',
    },
    steam: {
      wrong_tradelink: 'رابط التداول خاطئ',
      private_inventory: 'المخزون الخاص Steam',
      cannot_check_tradeban: 'لا يمكننا التحقق من حظر التداول',
      cannot_check_tradehold: 'لا يمكننا التحقق من تعليق التداول',
      vac_ban: 'حظر VAC',
      trade_ban: 'حظر التداول',
      private_profile: 'الملف الشخصي الخاص Steam',
      tradehold: 'تعليق التداول',
      wrong_token: 'رمز خاطئ',
      missing_token: 'رابط تداول Steam مفقود',
      missing_steam_id: 'معرف Steam مفقود',
      community_ban: 'حظر المجتمع',
      economy_ban: 'حظر اقتصادى',
      platform_offline: 'لا يوجد اتصال مع ستيم، قد تكون الخوادم غير متاحة. يرجى المحاولة مرة أخرى لاحقًا.',
      cannot_check_escrow: 'لا يمكن التحقق من الضمان',
      escrow: 'أنت تستخدم حماية البريد الإلكتروني Steam Guard وهذا لا يكفي للتداول مع الروبوتات الخاصة بنا. يجب عليك تفعيل حماية الجوال Steam Guard لتتمكن من التداول مع الروبوتات الخاصة بنا.',
      fresh_account: 'تحتاج إلى إعداد ملف تعريف Steam أولاً',
    },
    mutex: {
      long_lock: 'قفل طويل، حاول مرة أخرى في {ttl} ثانية',
      exclusive_lock: 'قفل حصري',
    },
    api: {
      missing_apikey: 'مفتاح API مفقود',
      missing_secret: 'API مفقود السر',
      wrong_ip_address: 'عنوان IP خاطئ',
      private_ip_address: 'عنوان IP الخاص',
      wrong_apikey: 'خطأ في مفتاح الواجهة البرمجية',
    },
    record: {
      item_not_found: 'العنصر غير موجود',
      item_not_owned: 'العنصر غير مملوك',
      own_item: 'البند الخاص بي',
      there_are_no_records: 'لا توجد سجلات للعرض',
      record_already_exists: 'السجل موجود بالفعل',
      record_not_exists: 'السجل غير موجود',
      already_exists: 'موجود بالفعل',
      not_exists: 'لا يوجد',
      not_updated: 'غير محدث',
      forbidden: 'ممنوع',
    },
    bot: {
      not_found: 'الروبوت غير موجود',
      not_available: 'الروبوت غير متوفر',
    },
    wallet: {
      cannot_transfer_money: 'لا يمكن نقل الأموال',
      amount_negative: 'المبلغ سالب',
      amount_positive: 'المبلغ إيجابي',
      card_scoring_too_low: 'تسجيل البطاقة منخفض جدا',
      not_enough_balance: 'لا يوجد رصيد كافي',
      kyc_window_limit: 'نافذة الحد الأقصى للتحقق من الهوية KYC',
      service_window_limit: 'نافذة الخدمة المحدودة',
      amount_limit: 'الحد الأقصى للمبلغ',
      wrong_wallet_address: 'عنوان المحفظة خاطئ',
      card_not_found: 'البطاقة غير موجودة',
      cannot_process_transaction: 'لا يمكننا معالجة عمليتك',
      only_past_months_accepted: 'فقط الأشهر السابقة مقبولة',
      only_visa_allowed: 'فقط البطاقات الفيزا مسموح بها',
      you_cannot_complete_this_action: 'لا يمكنك إكمال هذا الإجراء لأن لديك أموال غير كافية في حسابك.',
      you_need_to_deposit_at_least_x: 'تحتاج إلى إيداع مبلغ لا يقل عن {x} لإكمال هذا الإجراء.',
    },
    gift_code: {
      not_found: 'الرمز غير موجود',
      already_used: 'الرمز تم استخدامه بالفعل',
      own_code: 'هذا هو الرمز الخاص بك',
    },
    partner: {
      subaccount_not_enabled: 'الحساب الفرعي غير مفعل',
      link_account_first: 'ربط الحساب أولا',
      account_already_linked: 'تم ربط الحساب بالفعل',
      wrong_phrase: 'العبارة الخاطئة',
      cannot_link_yourself: 'لا يمكن ربط نفسك',
      account_already_exists: 'الحساب موجود بالفعل',
    },
    payment: {
      card_scoring: 'تصنيف البطاقة منخفض جدا',
      payment_issue: 'مشكلة في الدفع',
    },
    auth: {
      failed_to_authenticate: 'فشل في التوثيق',
      not_valid_identity: 'الهوية ليست صالحة',
      authentication_failed: 'فشلت عملية المصادقة',
    },
    social: {
      cannot_create_chat: 'لا يمكن إنشاء الدردشة',
    },
    support: {
      wrong_status: 'الحالة الخاطئة',
      ticket_limit: 'الحد المسموح بالتذاكر',
    },
    ipn: {
      verification_issue: 'مشكلة التحقق',
    },
    affiliate: {
      same_code: 'نفس الرمز',
      code_taken: 'هذا الرمز مأخوذ بالفعل',
      not_activated: 'غير مفعل',
      not_enough_balance: 'لا يوجد رصيد كافي',
    },
    bam: {
      bam_steam_015: 'الربوتات فقدت جلسات ستيم. يرجى المحاولة مرة أخرى بعد بضع دقائق.',
    },
  },
  validator: {
    required: 'هذا الحقل مطلوب.',
    string: 'هذا الحقل يجب أن يكون سلسلة نصية.',
    stringEmpty: 'هذا الحقل يجب ألا يكون فارغا.',
    stringMin: 'هذا الحقل يجب أن يكون طوله على الأقل {expected} حرفًا.',
    stringMax: 'هذا الحقل يجب أن يكون طوله على الأكثر {expected} حرفًا.',
    stringLength: 'هذا الحقل يجب أن يكون طوله {expected} حرفًا.',
    stringPattern: 'هذا الحقل لا يتطابق مع النمط المطلوب.',
    stringPatternLatin: 'يرجى استخدام الأحرف اللاتينية فقط.',
    stringContains: 'هذا الحقل يجب أن يحتوي على النص \'{expected}\'.',
    stringEnum: 'هذا الحقل لا يتطابق مع أي من القيم المسموح بها.',
    stringNumeric: 'هذا الحقل يجب أن يكون سلسلة رقمية.',
    stringAlpha: 'هذا الحقل يجب أن يكون سلسلة أبجدية.',
    stringAlphanum: 'هذا الحقل يجب أن يكون سلسلة أبجدية رقمية.',
    stringAlphadash: 'هذا الحقل يجب أن يكون سلسلة أبجدية متصلة.',
    stringHex: 'هذا الحقل يجب أن يكون سلسلة سداسية.',
    stringSingleLine: 'هذا الحقل يجب أن يكون سلسلة نصية واحدة.',
    stringBase64: 'هذا الحقل يجب أن يكون سلسلة base64.',
    number: 'هذا الحقل يجب أن يكون رقمًا.',
    numberMin: 'هذا الحقل يجب أن يكون أكبر من أو يساوي {expected}.',
    numberMax: 'هذا الحقل يجب أن يكون أقل من أو يساوي {expected}.',
    numberEqual: 'هذا الحقل يجب أن يكون مساويًا لـ {expected}.',
    numberNotEqual: 'هذا الحقل لا يمكن أن يكون مساويًا لـ {expected}.',
    numberInteger: 'هذا الحقل يجب أن يكون عدد صحيح.',
    numberPositive: 'هذا الحقل يجب أن يكون رقمًا إيجابيًا.',
    numberNegative: 'هذا الحقل يجب أن يكون رقمًا سلبيًا.',
    array: 'هذا الحقل يجب أن يكون مصفوفة.',
    arrayEmpty: 'هذا الحقل يجب ألا يكون مصفوفة فارغة.',
    arrayMin: 'هذا الحقل يجب أن يحتوي على الأقل {expected} عناصر.',
    arrayMax: 'هذا الحقل يجب أن يحتوي على عدد أقل من أو يساوي {expected} عناصر.',
    arrayLength: 'هذا الحقل يجب أن يحتوي على {expected} عناصر.',
    arrayContains: 'يجب أن يحتوي هذا الحقل على العنصر \'{expected}\'.',
    arrayUnique: 'القيمة \'{actual}\' لا تجعل القيم \'{expected}\' فريدة.',
    arrayEnum: 'القيمة \'{actual}\' لا تتطابق مع أي من القيم \'{expected}\'.',
    tuple: 'هذا الحقل يجب أن يكون مصفوفة.',
    tupleEmpty: 'هذا الحقل يجب ألا يكون مصفوفة فارغة.',
    tupleLength: 'هذا الحقل يجب أن يحتوي على {expected} عناصر.',
    boolean: 'هذا الحقل يجب أن يكون منطقيا.',
    currency: 'هذا الحقل يجب أن يكون بتنسيق عملة صالحة',
    date: 'هذا الحقل يجب أن يكون تاريخاً.',
    dateMin: 'هذا الحقل يجب أن يكون أكبر من أو يساوي {expected}.',
    dateMax: 'هذا الحقل يجب أن يكون أقل من أو يساوي {expected}.',
    enumValue: 'لا يتطابق قيمة هذا الحقل \'{expected}\' مع أي من القيم المسموح بها.',
    equalValue: 'يجب أن يكون قيمة هذا الحقل مساوية لـ \'{expected}\'.',
    equalField: 'يجب أن يكون قيمة هذا الحقل مساوية لقيمة الحقل \'{expected}\'.',
    forbidden: 'هذا الحقل ممنوع.',
    function: 'هذا الحقل يجب أن يكون وظيفة.',
    email: 'هذا الحقل يجب أن يكون بريد إلكتروني صحيح.',
    emailEmpty: 'هذا الحقل يجب ألا يكون فارغا.',
    emailMin: 'هذا الحقل يجب أن يكون طوله على الأقل {expected} حرفًا.',
    emailMax: 'هذا الحقل يجب أن يكون طوله على الأكثر {expected} حرفًا.',
    luhn: 'يجب أن يكون هذا الحقل بمثابة مجموع اختباري صالح لـ Luhn',
    mac: 'هذا الحقل يجب أن يكون عنوان MAC صالح.',
    object: 'هذا الحقل يجب أن يكون هادف.',
    objectStrict: 'هذا الهدف يحتوي على مفاتيح محظورة: \'{actual}\'.',
    objectMinProps: 'يجب أن يحتوي هذا الهدف على الأقل {expected} خصائص.',
    objectMaxProps: 'هذا الكائن يجب أن يحتوي على {expected} خصائص على الأكثر.',
    url: 'هذا الحقل يجب أن يكون له عنوان URL صحيح.',
    urlEmpty: 'هذا الحقل يجب ألا يكون فارغا.',
    uuid: 'هذا الحقل ليس بتنسيق رمز صالح.',
    uuidVersion: 'يجب أن يكون هذا المجال نسخة UUID صالحة مقدمة.',
    classInstanceOf: 'هذا الحقل يجب أن يكون مثيلًا للفئة \'{expected}\'.',
    objectID: 'هذا الحقل يجب أن يكون معرف هدف صالح',
    record: 'هذا الحقل يجب أن يكون هادف.',
  },
  body: {
    language: 'اللغة',
    currency: 'العملة',
    currency_warning: 'جميع العمليات تتم بالدولار الأمريكي، والعملات الأخرى تتم تحويلها من الدولار الأمريكي وتؤثر فقط على طريقة عرض الصفحة. قد تؤدي تغيرات أسعار صرف العملات إلى زيادة أو انخفاض رصيدك.',
    choose_game: 'اختر لعبة',
    slider: {
      title_1: 'تحديث أسلوبك،',
      title_2: 'السيطرة على اللعبة',
      content_1: 'اكتشف مجموعة الجلود النهائية',
      content_2: 'لتعزيز تجربة اللعب الخاصة بك.',
      tile_1: 'قم بتعظيم تجربتك في الألعاب',
      tile_2: 'احصل على أفضل قيمة مقابل أموالك',
      tile_3: 'استمتع بالتداول الآمن والسلس',
    },
    footer_description: 'في BitSkins ، كنا ملتزمين بتوفير منصة آمنة وموثوقة للاعبين لشراء وبيع العناصر من الألعاب الشهيرة مثل CS2 و Dota 2 و Rust و TF2. منذ إطلاقنا في عام 2015 ، قمنا بخدمة الملايين من العملاء المرتاحين بنجاح ، والتزامنا بالسلامة والأمان لا يزال أقوى من أي وقت مضى.',
    footer_disclaimer: '© 2015 - {year} BitSkins. مدعوم بواسطة Steam. غير مرتبط بشركة Valve Corp.',
    footer_email_support: 'إذا كنت بحاجة للدعم',
    footer_email_security: 'إذا كنت ترغب في الإبلاغ عن الأخطاء',
    footer_email_partnership: 'إذا كنت ترغب في التعاون',
    market: 'السوق',
    cart: 'عربة التسوق',
    cart_empty: 'سلة التسوق الخاصة بك فارغة',
    clear_cart: 'مسح السلة',
    checkout: 'الدفع',
    in_the_cart: 'في السلة',
    total: 'إجمالي',
    go_to_market: 'اذهب إلى السوق',
    trustpilot_alt: 'ثق بـ Trustpilot مع {stars} نجمة و {reviews} تقييم',
    reload_website: 'أعد تحميل الموقع!',
    app_error: 'خطأ في التطبيق: {error}',
    latest_articles: 'أحدث المقالات',
    steam_login: 'تسجيل الدخول إلى Steam',
  },
  maintenance: {
    we_will_be_back_soon: 'سنعود قريبًا',
    we_are_down_for_maintenance: 'نحن نقوم بالصيانة ولكن سنعود على الإنترنت قريبًا.',
    sorry_for_the_inconvenience: 'عذراً على الإزعاج وأراك قريباً!',
  },
  account: {
    email: {
      required: 'عنوان البريد الإلكتروني مطلوب',
      required_for_this_payment_method: 'لا يمكنك استخدام طريقة الدفع هذه لأنك لم تقم بإعداد عنوان بريدك الإلكتروني.',
      you_can_start_now: 'يمكنك بدء عملية الإعداد الآن.',
      setup: 'إعداد البريد الإلكتروني',
    },
    add_funds: 'إضافة الأموال',
    my_store: 'متجري',
    selling: 'بيع',
    transactions: 'المعاملات',
    settings: 'الإعدادات',
    steam_settings: {
      open_settings: 'افتح الإعدادات',
      open_steam_settings: 'افتح ملف تعريف Steam',
      what_is_steam_guard: 'ما هو حارس Steam؟',
      inventory_status: 'حالة المخزون',
      profile_status: 'حالة الملف الشخصي',
      change_trade_link: 'تغيير رابط التداول',
    },
    logout: 'تسجيل الخروج',
    inventory: 'المخزون',
    banned: {
      you_are_banned: 'أنت <span class="text-cr">محظور</span>',
      your_account_has_been_banned: 'تم حظر حسابك لانتهاك قوانيننا.',
      your_account_has_been_blocked: 'تم حظر حسابك لانتهاكك لشروطنا',
      if_you_believe: 'إذا كنت تعتقد أنها كانت خطأ يمكنك الاتصال بنا على support{\'@\'}bitskins.com',
      terms_of_use: 'شروط الاستخدام',
    },
    account_blocked: 'حساب محظور',
    api_access: 'وصول API',
  },
  balance: {
    wallet: 'محفظة',
    withdraw: 'سحب',
    withdraw_to: 'انسحب إلى',
    withdraw_again: 'انسحب مرة أخرى',
    withdrawable: 'قابل للسحب',
    total: 'إجمالي',
    balance: 'التوازن',
    deposits_and_sales: 'الودائع والمبيعات',
    proceeds_from_sales: 'عائدات من المبيعات',
    deposit: 'إيداع',
    locked: 'مغلق',
    funds_locked: 'الأموال المغلقة في المعاملات',
    pending_withdrawals: 'السحب المعلقة',
    thank_you_for_your_payment: 'شكراً لدفعتك',
    your_money_will_arrive_soon: 'سيصل مالك قريبًا',
    your_payment_is_still_processing: 'معالجة الدفع الخاص بك لا تزال قيد التنفيذ، ولكن يجب أن تظهر الأموال في حسابك قريبًا.',
    in_case_you_do_not_receive: 'في حال عدم استلام الأموال الخاصة بك في غضون 15 دقيقة، يرجى التواصل مع دعمنا.',
    payment_pending: 'الدفع قيد الانتظار',
    payment_failed: 'الدفع فشل',
    payment_canceled: 'الدفع تم إلغاؤه',
    payment_has_been_cancelled: 'تم إلغاء الدفع حسب الطلب',
    unfortunately_we_were_unable: 'للأسف لم نتمكن من معالجة دفعتك.',
    please_try_again: 'يرجى المحاولة مرة أخرى',
    if_the_problem_persists: 'إذا استمرت المشكلة، يرجى الاتصال بدعمنا. يمكنك أيضًا محاولة استخدام طريقة دفع مختلفة.',
    back_to_wallet: 'العودة إلى المحفظة',
    total_description: 'الأموال التي تأتي من إيداعاتك ومبيعاتك.',
    withdrawable_description: 'عائدات المبيعات. يمكن سحب هذه الأموال أو إنفاقها على شراء العناصر.',
    locked_description: 'الأموال المغلقة مؤقتًا التي لا يمكن إنفاقها أو سحبها. السبب في قفل الأموال هو وجود طلبات شراء قائمة، شراء العناصر، وما إلى ذلك...',
    deposit_with_cryptocurrencies: 'إيداع بواسطة العملات المشفرة:',
    deposit_with_standard_payment_methods: 'إيداع باستخدام طرق الدفع القياسية:',
    withdraw_with_cryptocurrencies: 'سحب بواسطة العملات المشفرة:',
    withdraw_with_standard_payment_methods: 'سحب بواسطة طرق الدفع القياسية.',
    your_amount: 'مبلغك',
    your_limit: 'حدك',
    your_limits: 'حدودك',
    increase_your_limits: 'زيادة حدودك',
    payment_not_available_in_the_following_countries: 'هذا الطريقة الدفع غير متاحة في البلدان التالية:',
    the_price_is_updated_every_60_seconds: 'السعر يتم تحديثه كل 60 ثانية وهو السعر المتوسط الذي يتم جمعه من عدة تبادلات.',
    rate_includes_x_fee: 'تشمل الأجرة {x}% رسوم.',
  },
  not_found: {
    title: 'الصفحة غير موجودة',
    message: 'يبدو أنك قد ضللت. يمكنك العثور على جلود أحلامك على صفحة السوق.',
  },
  login: {
    welcome_to_bitskins: 'مرحبًا بك في BitSkins',
    sign_in: 'تسجيل الدخول',
    sign_up: 'التسجيل',
    rules_text: 'أؤكد أنني عمري 18 عامًا أو أكبر وأوافق على',
    sign_in_with_steam: 'تسجيل الدخول باستخدام Steam',
    sign_up_with_steam: 'سجل مع Steam',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    already_have_an_account: 'هل لديك حساب بالفعل؟ انقر هنا',
    to_login: 'لتسجيل الدخول',
    to_login_via_email: 'لتسجيل الدخول عبر البريد الإلكتروني',
    login_via_email: 'تسجيل الدخول عبر البريد الإلكتروني',
    log_in_using_your_email: 'تسجيل الدخول باستخدام عنوان البريد الإلكتروني الخاص بك وكلمة المرور.',
    forgot_password: 'نسيت كلمة المرور؟',
    login_via_steam: 'تسجيل الدخول عبر Steam',
    register_first: 'أولاً، تحتاج إلى التسجيل',
    passwords_not_migrated: 'للأسف، خلال التحديث الأخير لم نتمكن من نقل كلمة المرور الخاصة بك، لذلك ستحتاج إلى إعادة تعيينها.',
  },
  common: {
    monthly: 'شهري',
    x_to_y: '{x} إلى {y}',
    minimum_x: 'الحد الأدنى {x}',
    maximum_x: 'الحد الأقصى {x}',
    click: 'انقر',
    claim: 'المطالبة',
    or: 'أو',
    and: 'و',
    confirm: 'تأكيد',
    continue: 'استمر',
    cancel: 'إلغاء',
    enable: 'تمكين',
    enabled: 'ممكّن',
    disable: 'عطل',
    disabled: 'معطل',
    download: 'تحميل',
    twofa: 'المصادقة ثنائية العوامل',
    terms_of_use: 'شروط الاستخدام',
    privacy_policy: 'سياسة الخصوصية',
    cookie_policy: 'سياسة ملفات تعريف الارتباط',
    about_us: 'من نحن',
    changelog: 'تغيير السجل',
    faq: 'الأسئلة المتكررة',
    support: 'دعم',
    affiliate: 'شريك تابع',
    blog: 'مدونة',
    careers: 'وظائف',
    api: 'واجهة برمجة التطبيقات',
    service_status: 'حالة الخدمة',
    loading: 'تحميل...',
    buy_skins: 'شراء الجلود',
    sell_skins: 'بيع الجلود',
    popular: 'شعبي',
    skin_categories: 'فئات الجلد',
    payments: 'المدفوعات',
    about_bitskins: 'حول BitSkins',
    social_media: 'وسائل التواصل الاجتماعي',
    follow_us: 'اتبعنا وانضم إلى مجتمعنا!',
    enter_your_email: 'أدخل عنوان بريدك الإلكتروني',
    phone_number: 'رقم الهاتف',
    verify: 'تحقق',
    add: 'إضافة',
    update: 'تحديث',
    check_spam_folder: 'إذا لم تتمكن من العثور على البريد الإلكتروني في صندوق الوارد الخاص بك، يرجى التحقق من مجلد البريد المزعج.',
    here: 'هنا',
    edit: 'تعديل',
    save: 'حفظ',
    copy: 'نسخ',
    back: 'الى الخلف',
    back_to_login: 'العودة إلى تسجيل الدخول',
    clear: 'واضح',
    quantity: 'الكمية',
    name: 'الاسم',
    bot_name: 'اسم الروبوت',
    steam: 'Steam',
    steam_id: 'معرف Steam',
    steam_group: 'مجموعة Steam',
    browser: 'متصفح',
    on: 'على',
    off: 'إيقاف',
    hidden: 'إخفاء',
    empty: 'فارغ',
    expires_in: 'تنتهي في',
    member_since: 'عضو منذ',
    close: 'أغلق',
    paint_seed_value: 'بذرة الطلاء: {value}',
    error: 'خطأ',
    retry: 'إعادة المحاولة',
    no_options_available: 'لا خيارات متاحة',
    search: 'البحث',
    any: 'أي',
    min: 'بحد أدنى',
    max: 'بحد أقصى',
    no_limit: 'غير محدود',
    scroll_left: 'انتقل لليسار',
    scroll_right: 'انتقل لليمين',
    load: 'تحميل',
    delete: 'حذف',
    remove: 'إزالة',
    all: 'جميع',
    game: 'لعبة',
    reset: 'إعادة تعيين',
    in: 'في',
    optional: '(optional)',
    default: 'افتراضي',
    filter: 'تصفية',
    up_to: 'حتى',
    similar: 'مماثل',
    important: 'مهم',
    step: 'خطوة',
    share_link: 'رابط المشاركة',
    zoom: 'تكبير',
    found: 'تم العثور عليه',
    try_again: 'حاول مرة أخرى',
    of: 'من',
    timer: 'المؤقت',
    add_new: 'أضف جديد',
    and_more: 'وأكثر',
    check_status: 'تحقق من الحالة',
    resend_link: 'إعادة إرسال الرابط',
    back_to_home: 'العودة إلى الصفحة الرئيسية',
    data_visible_only_to_logged_in_users: 'هذه البيانات مرئية فقط للمستخدمين المسجلين',
    login: 'تسجيل الدخول',
    level: 'مستوى',
    twofa_code: '2FA رمز',
    id: 'بطاقة تعريف',
    position: 'موقع',
    amount: 'المبلغ',
    progressive_sum: 'المجموع التدريجي',
    date: 'تاريخ',
    active: 'نشط',
    yes: 'نعم',
    no: 'لا',
  },
  notifications: {
    change: 'تغيير',
    setup: 'إعداد',
    disconnect: 'قطع الاتصال',
    connect: 'متصل',
    notifications: 'الإشعارات',
    notifications_center: 'مركز الإشعارات',
    clear_all: 'مسح جميع الإشعارات',
    notifications_channels: 'قنوات الإشعارات',
    connected: 'متصل',
    all_notifications: 'جميع الإشعارات',
    sound: 'صوت',
    volume_mute: 'كتم الصوت',
    volume_full: 'الصوت عالى ',
    all_sounds: 'جميع الأصوات',
    off: 'إيقاف',
    on: 'على',
    steam_issues_title: 'مشاكل Steam',
    steam_issues_content: 'تواجه Steam مشاكل قد تؤثر على التداول، مما يتسبب في عدم معالجة أو إنشاء الصفقات.',
    name: {
      account_new_login: 'تسجيل دخول بحساب جديد',
      inventory_sold: 'المخزون المباع',
      inventory_buyorder: 'طلب شراء المخزون',
      wallet_deposit_done: 'إيداع المحفظة تم',
      support_new_reply: 'دعم الرد الجديد',
      support_ticket_closed: 'تم إغلاق تذكرة الدعم الفني',
      inventory_bargain_received: 'صفقة الجرد المستلمة',
    },
  },
  market: {
    non_scraped_only: 'غير مقشور فقط',
    set_price: 'تعيين السعر',
    game_not_found: 'لم يتم العثور على اللعبة',
    game_not_available: 'اللعبة غير متوفرة حاليًا',
    any_stickers: 'أي ملصقات',
    item_removed_from_sale: 'تمت إزالة العنصر من البيع',
    price_updated: 'تم تحديث السعر',
    item_withdrawn: 'تم سحب هذا العنصر',
    go_to_withdrawn: 'اذهب إلى العناصر المسحوبة',
    item_issue: 'لدينا مشكلة مع هذا العنصر',
    item_in_deposit_queue: 'هذا العنصر في قائمة الإيداع',
    item_in_withdraw_queue: 'هذا العنصر في قائمة الانسحاب',
    go_to_queued: 'اذهب إلى العناصر في الانتظار',
    item_in_bitskins_inventory: 'هذا العنصر موجود في مخزون BitSkins الخاص بك',
    go_to_inventory: 'اذهب إلى المخزون',
    go_to_issue: 'اذهب إلى المشاكل',
    maximum_price: 'السعر الأقصى',
    minimum_price: 'السعر الأدنى',
    average_price: 'السعر المتوسط',
    amount_sold: 'المبلغ المباع',
    withdrawal_batch_info: 'يرجى أن تكون على علم بأننا نرسل العناصر بالدفعات كل بضع دقائق.',
    queued: 'قيد التنفيذ',
    queued_description: 'هنا يمكنك العثور على العناصر التي تم تسجيلها للسحب أو الإيداع.',
    withdrawn: 'سحب',
    withdrawn_description: 'هنا يمكنك العثور على العناصر التي تم سحبها.',
    issues: 'مشاكل',
    issues_description: 'هنا يمكنك العثور على العناصر التي نواجه مشاكل معها. نحن نعمل حاليًا على حل هذه المشاكل.',
    max_items_selected: 'لا يمكنك تحديد أكثر من {limit} عناصر',
    item_status: 'حالة العنصر',
    search_for_stickers: 'ابحث عن الملصقات',
    this_item: '(this item)',
    no_items_found: {
      no_items_found: 'لا توجد عناصر',
      no_items_found_span: 'لا توجد عناصر',
      we_could_not_find_any_offers: 'لم نتمكن من العثور على أي عروض',
      for: 'لل',
      this_can_be_due_to_applied_filters: 'يمكن أن يكون ذلك بسبب التصفيات المطبقة. يمكنك مسح جميع التصفيات عن طريق النقر على الزر أدناه',
    },
    only_tradable_items: 'فقط العناصر التي يمكن تداولها',
    not_accepting: 'لا يتم قبوله',
    sell: 'بيع',
    skin: 'الجلد',
    items: 'العناصر',
    items_v2: 'العناصر',
    buy_orders: 'أوامر الشراء',
    search_for: 'ابحث عن عناصر {game}',
    search_for_items: 'البحث عن العناصر',
    reload: 'إعادة التحميل',
    item_name: 'اسم العنصر',
    enter_item_name: 'أدخل اسم العنصر',
    price: 'السعر',
    reset: 'إعادة تعيين',
    all_items: 'جميع العناصر',
    sort: 'فرز',
    add_sort: 'أضف فرز',
    steam_price: 'سعر Steam',
    reference_price: 'السعر المرجعي',
    steam_inventory: 'مخزون Steam',
    your_steam_inventory: 'مخزون Steam الخاص بك',
    bitskins_inventory: 'مخزون BitSkins',
    your_bs_inventory: 'مخزون BitSkins الخاص بك {extra}',
    refresh: 'تحديث',
    learn_how_to_sell: 'تعلم كيفية البيع',
    select_1_by_1: 'اختر 1 بواحدة',
    select_all: 'اختر الكل',
    selected_items: 'العناصر المحددة',
    items_amount: '{count} عناصر',
    offers: 'عروض',
    favorites: 'المفضلات',
    last: 'الأخير',
    viewed: 'عرض',
    same_price: {
      same_price_for: 'نفس السعر ل',
      all_items: 'جميع العناصر',
    },
    save_all: 'حفظ الكل',
    trade_hold: {
      name: 'تعليق التداول',
      between: 'مغلق بين {min} و {max} أيام',
      less: 'مغلق لمدة أقل من {value} يوم',
      any: 'أي تداول معلق',
      none: 'لا توجد تأخير في التداول',
      withdrawable_in_days_hours: 'قابل للسحب في {days} أيام، {hours} ساعات',
      withdrawable_in_hours_minutes: 'قابل للسحب في {hours} ساعات، {minutes} دقائق',
      tradable: 'قابل للتداول',
    },
    filter: {
      status: 'الحالة',
      date_from: 'تاريخ من',
      date_to: 'تاريخ إلى',
      amount_from: 'المبلغ من',
      amount_to: 'المبلغ المطلوب',
      price_from: 'السعر من',
      price_to: 'السعر إلى',
      service: 'الخدمة',
      item: 'العنصر',
      game: 'لعبة',
      type: 'نوع',
      quality: 'جودة',
      exterior: 'الخارجية',
      category: 'الفئة',
      collection: 'مجموعة',
      color: 'لون',
      family: 'عائلة الجلد',
      phase: 'مرحلة',
      rarity: 'ندرة',
      grade: 'الصف',
      killstreak: 'قتل متتالية',
      effect: 'تأثير',
      hero: 'بطل',
      nametag: 'شارة الاسم',
      hightier: 'المستوى العالي',
      stickers: 'ملصقات',
      slot: 'فتحة {value}',
      paint_seed: 'طلاء البذور',
      paint_index: 'فهرس الطلاء',
      sticker_counter: 'كمية الملصقات',
      float_value: 'طفوا',
      active: '{value} نشطة',
      by_slot_position: 'بواسطة موضع الفتحة',
      filter_name: 'تصفية الأسماء',
      you_can_have: 'يمكنك أن تمتلك',
      filters_saved: 'المرشحات المحفوظة.',
      choose_stickers: 'اختر ملصقات',
      no_stickers_found: 'لا توجد ملصقات',
      basic_filters: 'المرشحات الأساسية',
      advanced_filters: 'مرشحات متقدمة',
      clear_all_filters: 'مسح جميع الفلاتر',
      save_filters: 'حفظ المرشحات',
      my_filters: 'مرشحاتي',
      filters_are_not_available_on_this_page: 'المرشحات غير متوفرة في هذه الصفحة',
    },
    loading_item: 'تحميل العنصر',
    bestseller: 'أفضل البائعين',
    this_is_your_item: 'هذا هو عنصرك',
    action: {
      screenshot: 'لقطة شاشة',
      inspect: 'فحص في اللعبة',
      view_at_steam: 'عرض على Steam',
      check_on_steam_market: 'تحقق من سوق Steam',
      share: 'شارك',
      sell_instantly: 'بيع فورا',
      buy: 'شراء',
      remove_from_sale: 'إزالة من البيع',
      check_on_market: 'تحقق من السوق',
      item_page: 'صفحة العنصر',
      bulk_buy: 'شراء بالجملة',
      add_to_favorites: 'أضف إلى المفضلة',
      remove_from_favorites: 'إزالة من المفضلة',
      buy_now: 'اشترِ الآن',
      bump: 'Bump',
      sticker: 'العناصر التي تحمل هذا الملصق',
    },
    bump_minimum: 'التصادم متاح فقط للعناصر التي تستحق أكثر من {amount}',
    your_price: 'سعرك',
    cart: {
      add_to_cart: 'أضف إلى السلة',
      remove_from_cart: 'إزالة من السلة',
      add_stickers_to_cart: 'أضف الملصقات إلى السلة',
      remove: 'إزالة',
      in_cart: 'في السلة',
    },
    details: 'تفاصيل',
    tags: 'العلامات',
    do_you_want_rename: 'هل ترغب في إعادة تسمية العنصر الخاص بك؟',
    currently_not_available: 'حاليا غير متوفر',
    nametag: 'علامة الاسم',
    sales: 'المبيعات',
    private_offer: 'عرض خاص',
    private_offers: 'العروض الخاصة',
    private_offers_description: 'لديك {counter} عروض خاصة. يمكنك العثور عليها',
    public_offer: 'عرض عام',
    offer_visible_only_to_people_with_link: 'هذا العرض مرئي فقط للأشخاص الذين لديهم رابط له',
    checkout: {
      if_any: 'إذا كان أي من العناصر في سلة التسوق الخاصة بك غير متوفرة بعد الآن، فلن يتم إضافتها إلى طلبك.',
      remove_all_items: 'إزالة جميع العناصر',
      order_summary: 'ملخص الطلب',
      you_will_save: 'ستوفر',
      i_have_read: 'لقد قرأت ووافقت على شروط الخدمة وسياسة الخصوصية وأفهم أن جميع المشتريات نهائية وغير قابلة للاسترداد.',
      confirm_checkout: 'تأكيد الخروج',
      you_need_to_deposit_at_least_x: 'تحتاج إلى إيداع مبلغ لا يقل عن {amount} لشراء العناصر في سلة التسوق الخاصة بك.',
      you_cannot_complete: 'لا يمكنك إكمال طلبك لأن ليس لديك ما يكفي من الأموال في حسابك. تحتاج إلى إيداع مبلغ {amount} على الأقل لشراء العناصر في سلة التسوق الخاصة بك.',
      these_items_will_be_removed: 'هذه العناصر ستتم إزالتها من القائمة بعد الخروج.',
      this_item_will_not_be_included: 'هذا العنصر لن يتم تضمينه في طلبك',
      need_tos_accept: 'يجب أن توافق على شروط الخدمة وسياسة الخصوصية',
      no_items_selected: 'لا توجد عناصر محددة',
    },
    deposit_status: {
      available: 'متاح',
      missing: 'مفقود',
      not_accepting: 'لا يتم قبوله',
      wrong_price: 'سعر خاطئ',
      already_queue: 'بالفعل في قائمة الانتظار',
      locked: 'مغلق',
    },
    withdraw_progress: {
      status: 'حالة السحب',
      selected: 'محدد',
      waiting: 'انتظار',
      in_queue: 'في قائمة الانتظار',
      trade_link: 'رابط التداول',
      done: 'تمت العملية',
      error: 'خطأ',
      failed: 'فشل',
      pending: 'قيد التنفيذ',
    },
    trade_state: {
      Invalid: 'غير صالح',
      Active: 'نشطة',
      Accepted: 'قبلت',
      Countered: 'مواجهة',
      Expired: 'منتهية الصلاحية',
      Canceled: 'تم الإلغاء',
      Declined: 'رُفضت',
      InvalidItems: 'العناصر غير صالحة',
      CreatedNeedsConfirmation: 'تم إنشاؤها، تحتاج إلى تأكيد',
      CanceledBySecondFactor: 'تم إلغاءه بواسطة العامل الثاني',
      InEscrow: 'في الضمان',
    },
    trade_type: {
      deposit: 'إيداع',
      withdraw: 'سحب',
      bidirectional: 'ثنائي الاتجاه',
    },
    inventory: {
      history: 'التاريخ',
      active_trades: 'الصفقات النشطة',
      loading_your_inventory: 'تحميل المخزون الخاص بك',
      lower_sale_fee: '{value}% رسوم بيع أقل',
      group_diff_price: 'ليست جميع العناصر في المجموعة لديها نفس السعر',
      group_diff_delist: 'لم يتم وضع علامة على جميع العناصر في المجموعة للحذف',
      delist: 'إلغاء التداول',
      this_may_take_a_while: 'قد يستغرق هذا بعض الوقت',
      relist_items: 'أعد تدوين العناصر',
      cancel_relisting: 'إلغاء إعادة التدوين',
      cancel_withdrawal: 'إلغاء السحب',
      withdraw_items: 'سحب العناصر',
      cancel_editing: 'إلغاء التعديل',
      edit_items: 'تعديل العناصر',
      sell_items: 'بيع العناصر',
      steam_offers: 'عروض Steam',
      clear_withdraw_items: 'مسح العناصر',
      loading_inventory: 'تحميل المخزون',
      update_x_items: 'تحديث {amount} عناصر',
      delist_x_items: 'أزالة {amount} عناصر',
    },
    message: {
      failed_to_create_trade_offer: 'فشل في إنشاء عرض التداول',
      offer: 'عرض {hash}',
      offer_failed: 'فشل العرض (بحالة {state})',
      offer_confirmed: 'تم تأكيد عرضك وتم إدراج عناصرك للبيع بنجاح',
      offer_sent: 'تم إرسال عرض التداول الخاص بك',
      open_trade: 'فتح عرض التداول',
      withdraw: 'سحب العرض {hash}',
      withdraw_confirmed: 'تم قبول سحبك',
      offer_preparing: 'تم إعداد تداولك. سنرسل لك العرض قريبًا.',
      offer_active: 'تداولك جاهزة. قم بالقبول هنا',
      offer_needs_confirmation: 'تأكيد التداول في تطبيق الهاتف المحمول',
    },
    deposit_type: {
      public: 'عامة',
      public_description: 'سيتم رؤية عناصرك من قبل جميع مستخدمي BitSkins. هذا هو الخيار الأكثر شيوعًا للبيع.',
      private: 'خاص',
      private_description: 'سيتم رؤية عناصرك فقط من قبل الأشخاص الذين لديهم رابط لها. البيع الخاص أرخص بنسبة 50٪ من البيع العادي.',
      instant_sell: 'بيع فوري',
      instant_description: 'بعد إرسال العناصر إلى الروبوت الخاص بنا ، سيتم تحويل المبلغ إلى حسابك فوراً.',
    },
    click_to_open: 'انقر لفتح الرابط في علامة تبويب جديدة',
    no_active_trades: 'لا توجد صفقات نشطة',
    go_to_all_trades: 'اذهب إلى جميع الصفقات',
    update_trade_link: 'تحديث رابط التداول',
    withdraw: 'سحب',
    lowest_price: 'أدنى سعر:',
    no_filters_available: 'لا توجد مرشحات متاحة',
    select_a_hero: 'اختر بطلاً.',
    view_all_items: 'عرض جميع العناصر',
    stattrak: 'StatTrak™',
    item_not_available: 'هذا العنصر غير متوفر بعد الآن',
    out_of_stock: 'إنتهى من المخزون',
    find_similar_item: 'ابحث عن عنصر مماثل',
    find_similar_items: 'ابحث عن عناصر مماثلة',
    sell_for: 'بيع ل',
    recommended: 'موصى به',
    price_discounted: 'السعر المخفض',
    price_average: 'السعر المتوسط (recommended)',
    price_expensive: 'سعر مرتفع',
    sticker: 'ملصق',
    more: 'أكثر',
    recent: 'حديث',
    item_not_found: 'العنصر غير موجود',
    for: 'لل',
    you_will_pay: 'ستدفع',
    fade: 'تلاشي: {value}%',
    see_all_items: 'انظر جميع العناصر {amount}',
    it_my_take_a_while: 'قد يستغرق هذا بعض الوقت',
    no_transactions_found: 'لا توجد معاملات تم العثور عليها',
    item: 'العنصر',
    edit: 'تعديل',
    add_items_to_edit: 'أضف عناصر للتعديل',
    add_items_to_delist: 'أضف العناصر لإزالتها',
    add_items_to_sale: 'أضف عناصر للبيع',
    add_items_to_withdraw: 'أضف عناصر للسحب',
    group_by_name: 'تجميع حسب الاسم',
    select_items_from_your_inventory: 'حدد العناصر من مخزونك',
    earnings: 'أرباح',
    total_fee: 'الرسوم الإجمالية',
    total_amount: 'المبلغ الإجمالي',
    confirm_purchase: 'تأكيد الشراء',
    thank_you_for_shopping_with_us: 'شكرا لك على التسوق معنا!',
    you_have_purchased_x_items_for: 'لقد قمت بشراء <span class="text-cp">{x}</span> عناصر بقيمة',
    you_have_purchased_x_for: 'لقد قمت بشراء <span class="text-cp">{x}</span> ل',
    total: 'إجمالي',
    you_saved: 'أنت قمت بحفظه',
    see_your_inventory: 'انظر إلى مخزونك',
    you_bought: 'لقد اشتريت',
    order_details: 'تفاصيل الطلب',
    items_not_available: 'للأسف، بعض العناصر من سلة التسوق الخاصة بك أصبحت غير متوفرة، وبالتالي لم تتمكن من شرائها. فيما يلي يمكنك العثور على قائمة هذه العناصر.',
    total_price: 'السعر الإجمالي',
    withdraw_all_items: 'سحب جميع العناصر',
    private_listing: '{extra} قائمة خاصة',
    public_listing: '{extra} القائمة العامة',
    instant_sale_price: 'سعر البيع الفوري',
    not_accepted: 'غير مقبول',
    not_available: 'غير متوفر',
    no_sales_data: 'لا توجد بيانات مبيعات',
    create_buy_order: 'إنشاء أمر شراء',
    active_buy_orders: 'طلبات الشراء النشطة الخاصة بك',
    buy_orders_history: 'تاريخ أوامر الشراء',
    market_buy_orders: 'أوامر شراء السوق',
    recent_sales: 'المبيعات الأخيرة',
    selling_price: 'سعر البيع',
    sales_chart: 'رسم بياني للمبيعات',
    sales_history_will_be_available_soon: 'ستكون تاريخ مبيعات BitSkins و Steam متاحًا قريبًا',
    souvenir: 'تذكار',
    under: '{amount} وأقل',
    above: '{amount} وأعلى',
    amount_to_amount: 'من {amount1} إلى {amount2}',
    discount: 'خصم',
    value_off_or_more: '{value}% خصم أو أكثر',
    removed_items: 'العناصر المحذوفة',
    restore_all_items: 'استعادة جميع العناصر',
    add_x_items_to_edit: 'أضف {amount} عناصر للتحرير',
    add_x_items_to_sale: 'أضف {amount} عناصر للبيع',
    add_x_items_to_withdraw: 'أضف {amount} عناصر للسحب',
    sell_x_items: 'بيع {amount} عناصر',
    withdraw_x_items: 'سحب {amount} عناصر',
    first_you_need_to_select_an_item: 'أولاً، تحتاج إلى اختيار عنصر.',
    cheapest_price_on_bitskins: 'أرخص سعر على BitSkins:',
    final_price: 'السعر النهائي',
    check_quantity: 'تحقق من الكمية',
    cancel_selected_orders: 'إلغاء الطلبات المحددة',
    cancel_all_orders: 'إلغاء جميع الطلبات',
    community_rating: 'التصنيف المجتمعي:',
    rating: 'تصنيف',
    votes: 'التصويت',
    open_image: 'فتح الصورة',
    cheaper_than_steam_by_x: 'أرخص من Steam بنسبة {x}%',
    there_are_other_items_you_may_like: 'هناك عناصر أخرى قد تعجبك...',
    available_variants: 'المتغيرات المتاحة',
    picture: {
      playside: 'التشكيل الهجومى',
      backside: 'التشكيل الخلفي',
      steam: 'صورة سوق Steam',
    },
    buy_orders_not_available: 'أوامر الشراء غير متاحة حاليًا',
    confirm_price_change: 'تأكيد تغيير السعر',
    are_you_sure_to_change_price: 'هل أنت متأكد أنك تريد تغيير السعر إلى <span class="text-cp fw-sb">{price}</span>؟',
  },
  bumps: {
    heading: 'هل ترغب في بيع أغراضك بشكل أسرع دون خفض سعرها؟',
    subheading: 'لدينا شيء لك!',
    how_it_works: 'كيف يعمل؟',
    description: 'في BitSkins لدينا خيار الإعلان الذي يتيح لك تسليط الضوء على عناصرك في صفحة السوق وفي بعض الأماكن الأخرى على الموقع. إنها حلاً مثاليًا لشخص يرغب في تسريع عملية بيع العناصر دون الحاجة إلى خفض السعر. عندما تقوم بتسليط الضوء على عنصر ما، سيشاهده المزيد من الأشخاص وتزداد فرصة بيعه. يمكنك البدء في تسليط الضوء على عناصرك ابتداءً من 0.75 دولار أو أقل (please check our bumps packages).',
    your_active_x_autobumps: 'سيارتك {x} تصدم تلقائيًا',
    bumps_packages: 'حزم الصدمات',
    bumps: 'صدمات',
    bumps_title: 'صدمات',
    available_bumps: 'الصدمات المتاحة',
    buy_selected_package: 'شراء الحزمة المحددة',
    when_you_bump: 'عندما تصطدم بعنصر سيتم عرضه في الأماكن التالية:',
    step_1_title: 'في صفحة السوق في الشريط العلوي',
    step_2_title: 'في صفحة السوق في القسم الرئيسي',
    step_2_text: '(فقط إذا تم تعيين خيار الترتيب على "featured". هذا هو الخيار الافتراضي.)',
    step_3_title: 'على <span class="text-cp">الصفحة الرئيسية</span>',
    step_4_title: 'في صفحة العنصر في قسم <span class="text-cp">العناصر المماثلة</span>',
    step_5_title: 'في قسم <span class="text-cp">العناصر المقترحة</span>',
    after_bumping: 'بعد الاصطدام بعنصر، سيتم عرضه في المرتبة الأولى في كل قسم. ومع ذلك، إذا قام شخص آخر بإصطدام عنصره بعدك، فسيتم نقل عنصرك إلى المرتبة الثانية. سيكون عنصرك مرئيًا في كل قسم طالما لم يكن هناك عدد كافٍ من الاصطدامات التي ستدفعه خارج القسم.',
    how_to_bump: 'كيف يمكنني رفع عنصري؟',
    how_to_1: 'افتح قائمة العناصر',
    how_to_2: 'اختر الخيار <span class="text-cp">bump</span>',
    how_to_3: 'اختر نوع الاصطدام',
    how_to_4: 'تم!',
    table: {
      item: 'العنصر',
      quantity: 'الكمية',
      left: 'اليسار',
      period: 'الفترة',
      created_at: 'تم إنشاؤه في',
      updated_at: 'تحديثه في',
      next_bump_at: 'التصادم التالى في',
      action: 'فعل',
      status: 'الحالة',
    },
    auto_enabled: 'تم تمكين تصادم تلقائي',
    auto_disabled: 'إلغاء تلقائي للتصادم',
    single_bumped: 'تم اصطدام العنصر!',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'تأكيد إلغاء طلبات الشراء',
    are_you_sure_that_you_want_to_cancel: 'هل أنت متأكد أنك تريد إلغاء جميع طلبات الشراء الخاصة بك؟',
    create_buy_order: 'إنشاء أمر شراء',
    predict_place_in_queue: 'توقع المكان في قائمة الانتظار',
    your_place_in_the_queue: 'مكانك في قائمة الأنتظار:',
    may_purchase_items_with_trade_hold: 'أوامر الشراء قد تشتري العناصر مع التعليق التداولى.',
    create_a_buy_order_for_this_item: 'إنشاء أمر شراء لهذا العنصر',
    no_buy_orders_found: 'لا توجد طلبات شراء',
    position_in_queue: 'الموقع فى قائمه الأنتظار',
    this_is_your_buy_order: '(هذا هو طلب الشراء الخاص بك)',
    skin_name: 'اسم الجلد:',
    offers_on_market: 'عروض على السوق',
  },
  instant_sell: {
    confirmation: 'تأكيد البيع الفوري',
    you_can_sell_x: 'يمكنك بيع AWP | Asiimov (Field-Tested) فوراً واستلام 10 دولار.',
    the_funds_will_be_credited: 'سيتم تحويل الأموال إلى حسابك فوراً. إذا كنت ترغب في المتابعة، انقر على "بيع فورياً".',
  },
  sort: {
    select_option: 'اختر الخيار',
    apply: 'تطبيق',
    clear: 'واضح',
    default_order_placeholder: 'اختر خيارًا',
    select_order_placeholder: 'ترتيب الاختيار',
    default_sort: 'الترتيب الافتراضي',
    custom_sort: 'ترتيب مخصص',
    field: {
      price: 'السعر',
      discount: 'خصم',
      id: 'تاريخ الإضافة',
      bumped_at: 'مميز',
      suggested_price: 'السعر المقترح',
      asset_id: 'تاريخ الإضافة',
      float_value: 'طفوا',
      paint_index: 'فهرس الطلاء',
      paint_seed: 'طلاء البذور',
      extras_1: 'قيمة إضافية',
      extras_1_fade: 'تلاشى',
      amount: 'المبلغ',
      name: 'الاسم',
    },
    order: {
      price: {
        asc: 'الأرخص أولاً',
        desc: 'الغالي أولاً',
      },
      discount: {
        desc: 'الأعلى أولاً',
      },
      id: {
        asc: 'الأقدم أولاً',
        desc: 'الأحدث أولاً',
      },
      asset_id: {
        asc: 'الأقدم أولاً',
        desc: 'الأحدث أولاً',
      },
      bumped_at: {
        desc: 'افتراضي',
        asc: '',
      },
      default: {
        asc: 'الأدنى أولاً',
        desc: 'الأعلى أولاً',
      },
    },
  },
  pagination: {
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    records: 'السجلات',
  },
  popups: {
    click_confirmation_link: 'يرجى التحقق من صندوق البريد الوارد الخاص بك والنقر على رابط التأكيد لإكمال العملية.',
    steam_login_issue: {
      title: 'مشكلة تسجيل الدخول إلى Steam',
      an_error_occured: 'حدث خطأ أثناء محاولة تسجيل الدخول عبر Steam. يرجى المحاولة مرة أخرى.',
    },
    steam_inventory_private: {
      title: 'مخزون Steam الخاص بك هو خاص',
      we_were: 'لم نتمكن من تحميل مخزونك في Steam. يرجى تغيير حالة مخزونك إلى عامة.',
      you_can: 'يمكنك القيام بذلك في إعدادات Steam. تذكر أنه قد يستغرق بضع دقائق حتى نكتشف التغييرات.',
      steam_settings: 'إعدادات Steam',
    },
    account_deletion_in_progress: {
      title: 'حذف الحساب قيد التنفيذ...',
      process_started: 'لقد بدأت عملية حذف الحساب.',
      account_will_be_deleted: 'سيتم حذف حسابك في',
      cancel_deletion: 'إلغاء الحذف',
      confirm_deletion: 'تأكيد الحذف',
      check_your_email: 'تحقق من بريدك الإلكتروني',
    },
    account_deletion_confirm: {
      title: 'تأكيد حذف الحساب',
      subtitle: 'هل أنت متأكد أنك تريد حذف حسابك؟',
      once_you_confirm: 'بمجرد تأكيدك، ستتم تسجيل خروجك تلقائيًا وسيتم حذف جميع بيانات حسابك نهائيًا بعد مرور أسبوعين. خلال هاتين الأسبوعين، ستكون قادرًا على إلغاء عملية الحذف عن طريق تسجيل الدخول إلى حسابك.',
      once_your_account_is: 'بمجرد حذف حسابك ، ستتمكن من إنشاء حساب جديد في BitSkins عن طريق تسجيل الدخول إلى الموقع.',
      however_you_will_not: 'ومع ذلك، لن يكون لديك الوصول إلى البيانات المحذوفة.',
      if_you_want_to_continue: 'إذا كنت ترغب في المتابعة، انقر على تأكيد وانقر على رابط التأكيد في البريد الإلكتروني الذي أرسلناه لك.',
      login: 'تحتاج إلى تسجيل الدخول لتأكيد حذف الحساب',
      canceled: 'تم إلغاء حذف الحساب',
      confirmed: 'تم تأكيد حذف الحساب',
    },
    account_deletion_check_your_email: {
      title: 'تحقق من بريدك الإلكتروني',
      to_complete: 'لإكمال عملية حذف الحساب، انقر على رابط التأكيد في البريد الإلكتروني الذي أرسلناه لك.',
    },
    twofa_enable: {
      already_done: 'لقد قمت بتمكين 2FA بالفعل.',
      setup_email_before: 'لكي تمكن 2FA ، تحتاج إلى إعداد البريد الإلكتروني أولاً.',
      twofa_authentication_adds: 'تعمل المصادقة ذات العاملين (2FA) على إضافة طبقة إضافية من الأمان إلى حسابك عن طريق طلب طريقتين (عاملين) للتحقق من هويتك. يُوصى بشدة بتمكين 2FA للحفاظ على سلامة حسابك، حيث يمنع الدخول غير المرغوب فيه دون الوصول إلى رمز 2FA الإضافي.',
      setup_twofa: 'قم بإعداد المصادقة الثنائية',
      if_you_dont_have_an_authenticator_app: 'إذا كنت لا تملك تطبيق المصادقة',
      we_recommend: 'نوصي باستخدام تطبيق Google Authenticator أو Authy لمستخدمي Android و iOS. إذا كنت ترغب في استخدام التطبيق على جهاز الكمبيوتر الخاص بك، يمكنك تنزيل وتثبيت Authy أو استخدام Google Authenticator extension في المتصفح الخاص بك.',
      scan_the_qr_code: '<span class="text-cp">مسح</span> رمز الاستجابة السريعة',
      open_your_authenticator_app: 'افتح تطبيق المصادقة الخاص بك وقم بمسح رمز الاستجابة السريعة أو أدخل المفتاح السري يدويًا.',
      secret_key: 'مفتاح سري',
      this_secret_key_will_be_valid_for_x_seconds: 'هذا المفتاح السري سيكون صالحًا لمدة <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'احفظ هذا المفتاح السري في مكان آمن. سيسمح لك باستعادة الوصول إلى رموز 2FA الخاصة بك عندما تفقد الوصول إلى تطبيق المصادقة.',
      enter_the_6_digit_code: 'أدخل الرمز المكون من <span class="text-cp">6 أرقام</span> الذي تم إنشاؤه بواسطة تطبيق المصادقة الخاص بك',
      enter_the_code_from_the_email: 'أدخل الرمز من البريد الإلكتروني',
      enter_the_verification_code: 'أدخل رمز التحقق الذي أرسلناه إلى <span class="text-cp">{email}</span>.',
      desktop: 'سطح المكتب',
    },
    twofa_enabled: {
      now_your_account_is: 'الآن حسابك محمي بواسطة المصادقة الثنائية.',
      all_future_logins: 'جميع تسجيلات الدخول المستقبلية ستتطلب الآن إدخال رمز يتم توفيره من قبل تطبيق المصادقة الخاص بك.',
    },
    twofa_enter_code: 'أدخل رمز 2FA الذي تم إنشاؤه بواسطة تطبيق المصادقة الخاص بك.',
    twofa_disable: {
      title: 'تعطيل المصادقة الثنائية',
      enter_the_6_digit_code: 'أدخل الرمز المكون من 6 أرقام الذي تم إنشاؤه بواسطة تطبيق المصادقة الخاص بك.',
      cannot_access: 'لا يمكن الوصول إلى رمز التحقق الخاص بك؟ يرجى الاتصال بنا على',
    },
    twofa_disabled: 'حسابك لم يعد محميًا بواسطة المصادقة الثنائية.',
    order_unable_to_process: {
      title: 'لم نتمكن من معالجة طلبك',
      an_error_occurred: 'حدث خطأ أثناء معالجة طلبك. <br> يرجى العودة إلى صفحة الخروج ومحاولة تقديم الطلب مرة أخرى.',
      back_to_checkout: 'العودة إلى الخروج',
      back_to_item: 'العودة إلى العنصر',
      information: 'إذا حدثت هذه الخطأ بشكل متكرر، يجب عليك التواصل معنا عبر <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">صفحة الدعم</a> وتضمين رمز الخطأ.',
    },
    phone_number_add: {
      title: 'أضف رقم هاتفك',
      to_continue: 'للمتابعة ، تحتاج أولاً إلى إضافة رقم هاتفك إلى حسابك.',
      add_number: 'أضف الرقم',
    },
    phone_number_confirmed: {
      title: 'تم تأكيد رقم الهاتف',
      your_phone_number: 'تم تأكيد رقم هاتفك.',
    },
    phone_number_verify: {
      title: 'تحقق من رقم هاتفك',
      to_verify: 'للتحقق من رقم هاتفك يجب عليك إدخال رمز التحقق الذي أرسلناه إلى',
      enter_sms_code: 'أدخل رمز الرسالة القصيرة',
      you_cannot_update: 'لا يمكنك تحديث رقم هاتفك في هذه المرحلة. ستتمكن من القيام بذلك في {minutes} دقائق.',
    },
    phone_number_verification_in_progress: {
      title: 'عملية التحقق من رقم الهاتف قيد التنفيذ',
      if_you_wish: 'إذا كنت ترغب في ذلك يمكنك تحديث رقم هاتفك أو إعادة إرسال رمز التحقق.',
      send_code: 'أرسل الرمز',
    },
    email_address_add: {
      your_email_address: 'عنوان بريدك الإلكتروني',
      by_providing_my_email: 'بتقديم عنوان بريدي الإلكتروني، أوافق على استلام الاتصالات التسويقية',
      verification_in_progress: 'تحقق من البريد الإلكتروني قيد التقدم',
      to_verify: 'للتحقق من عنوان بريدك الإلكتروني، يجب عليك النقر على رابط التأكيد في البريد الإلكتروني الذي أرسلناه إليك.',
      if_you_wish: 'إذا كنت ترغب في ذلك يمكنك تحديث عنوان بريدك الإلكتروني أو إعادة إرسال رابط التفعيل.',
    },
    email_address_verify: {
      we_are_verifying: 'نحن نتحقق من عنوان بريدك الإلكتروني وقد يستغرق الأمر بعض الوقت...',
      confirmed: 'تم تأكيد عنوان بريدك الإلكتروني.',
    },
    email_address_confirmed: {
      title: 'تم تأكيد عنوان البريد الإلكتروني',
      your_email_address: 'تم تأكيد عنوان بريدك الإلكتروني.',
    },
    enter_your_trade_url: {
      title: 'أدخل عنوان URL الخاص بك للتداول',
      to_continue: 'للمتابعة ، تحتاج أولاً إلى إعداد عنوان URL الخاص بالتداول الخاص بك. ستجده',
      your_trade_url: 'رابط التداول الخاص بك',
    },
    password_reset_enter_email: {
      forgot: 'نسيت كلمة السر الخاصة بك',
      password: 'كلمة السر؟',
      dont_worry: 'لا تقلق، أدخل عنوان بريدك الإلكتروني أدناه.',
      we_will_send: 'سنرسل لك رابطًا لإعادة تعيين كلمة المرور الخاصة بك.',
      send_reset_link: 'إرسال رابط إعادة التعيين',
      if_this_email: 'إذا كان هذا العنوان البريدي مرتبطًا بحساب BitSkins،',
      you_will_receive: 'ستتلقى رسالة بريد إلكتروني تحتوي على رابط لإعادة تعيين كلمة المرور الخاصة بك.',
    },
    password_reset_new_password: {
      enter_your: 'أدخل الخاص بك',
      new_password: 'كلمة مرور جديدة',
      enter_password: 'أدخل كلمة المرور',
      repeat_password: 'كرر كلمة المرور',
      save_password: 'حفظ كلمة المرور',
    },
    link_expired: {
      title: 'انتهت صلاحية الرابط',
      the_process_cannot: 'لا يمكن إكمال هذه العملية. الرابط قد انتهت صلاحيته بالفعل.',
      go_to_settings: 'اذهب إلى الإعدادات',
    },
    wrong_link: {
      title: 'رابط خاطئ',
      we_were_unable: 'لم نتمكن من معالجة طلبك. لقد قمت باتباع رابط خاطئ.',
    },
    trade_preparing: {
      title: 'نحن نعد عرض التداول الخاص بك',
      processing: 'قد يستغرق بضع ثوانٍ...',
    },
    trade_sent: {
      trade_offer_has_been_sent: '<span class="text-cp">تم إرسالها</span> عرض التداول الخاص بك لديه',
    },
    trade_done: {
      title: 'تم قبول عرض التداول',
      listed: 'لقد قمت بنجاح بإدراج عناصرك للبيع. يمكنك إدارتها في علامة التبويب <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">البيع</a>.',
      see_listed: 'انظر إلى العناصر المدرجة الخاصة بك',
      withdrawn: 'لقد قمت بسحب عناصرك بنجاح.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'تم تنفيذ عرض التداول الخاص بك',
      declined: 'رفضت',
      if_you: 'إذا لم ترفضه بنفسك فهذا يعني أن شخصًا ما يستخدم حسابك وقد تكون مقتنياتك في خطر من السرقة.',
      to_stay: 'يجب أن تتصرف بسرعة وتتبع هذه الخطوات لحماية ممتلكاتك.',
      step_revoke: 'أبطل مفتاح API Steam الخاص بك.',
      step_revoke_btn: 'إلغاء مفتاح API ',
      step_password: 'غير كلمة مرورك في Steam.',
      step_password_btn: 'تغيير كلمة المرور',
      step_deauth: 'إلغاء تفويض جميع الأجهزة على Steam.',
      step_deauth_btn: 'إلغاء تفويض الأجهزة',
      step_trade: 'إنشاء رابط تداول Steam جديد.',
      step_trade_btn: 'إنشاء رابط تداول جديد',
      step_new: 'قم بتعيين رابط التداول الجديد الخاص بك على BitSkins.',
      step_new_btn: 'قم بتعيين رابط تداول جديد',
      step_try: 'حاول إيداع العناصر الخاصة بك مرة أخرى وتحقق مما إذا استمرت المشكلة.',
      step_try_if: 'إذا استمرت المشكلة في الحدوث، قم بإيقاف جميع الصفقات واتصل بدعمنا.',
      contact_support: 'اتصل بالدعم الفني',
      information: 'تذكر أن أعضاء فريقنا والروبوتات لن يطلبوا أي إيداع عبر Steam Chat أو Discord أو أي مكان آخر - أي شخص يدعي أنه مشرف، إلخ.. هو كاذب ومحتمل أن يكون يحاول خداعك. كن آمنا!',
    },
    trade_failed: {
      offer_failed_title: 'فشلت عرض التداول',
      offer_failed_text: 'عذراً، لقد فشلت عرضك التداولى. يرجى المحاولة مرة أخرى.',
      offer_failed_to_create_title: 'فشل في إنشاء عرض تداولى',
      offer_failed_to_create_text: 'عذرًا، لم نتمكن من إنشاء عرض التداول الخاص بك. يرجى المحاولة مرة أخرى.',
      contact_support: 'إذا حدثت هذه الخطأ بشكل متكرر يجب عليك التواصل معنا من خلال صفحة الدعم.',
      support_page: 'صفحة الدعم',
      cannot_process: 'لا يمكننا معالجة عرض التداول الخاص بك',
      unfortunately_we_were_unable: 'عذرًا، لم نتمكن من معالجة عرض التداول الخاص بك. من المحتمل أن يكون لديك بالفعل عرض تداول نشط لهذه العناصر.',
    },
    items_not_available: {
      title: 'العناصر لم تعد متاحة للبيع',
      unfortunately: 'عذرًا، لكن العناصر الموجودة في سلة التسوق الخاصة بك <span class="text-cy-secondary">لم تعد متاحة للبيع</span>.',
      dont_worry: 'لا تقلق، يمكنك العثور على العديد من العناصر على صفحة السوق.',
      unavailable_items: 'العناصر غير المتاحة',
      back_to_market: 'العودة إلى السوق',
    },
    bump_purchase_confirmation: {
      title: 'تأكيد الشراء',
      do_you_want_to_purchase: 'هل ترغب في شراء {quantity} من الزيادات بسعر {price}؟',
      bumps_package: 'حزمة الصدمات',
    },
    bump_start: {
      title: 'اصدم العنصر الخاص بك',
      bump_your_item: 'قم بدفع عنصرك لتسليط الضوء عليه في صفحة السوق وفي بعض الأماكن الأخرى على الموقع. <br> يمكن أن يساعدك ذلك في بيع عنصرك بشكل أسرع لأنه سيلاحظه المزيد من الأشخاص. <br> إذا كنت ترغب في معرفة المزيد حول كيفية عمل ميزة الدفع.',
      click_here: 'انقر هنا',
      single_bump: 'نتوء واحدة',
      autobumps: 'تصدمات تلقائية',
      one_bump: '1 اصطدام',
      this_option_single_bump: 'هذا الخيار سيقوم برفع عنصرك مرة واحدة فقط ويكلف 0.75 دولار. إذا كان لديك بالفعل عروض متاحة في حسابك، فلن يتم خصم أي مبلغ من رصيدك.',
      this_option_autobumps: 'هذا الخيار سيقوم برفع عنصرك كل فترة زمنية محددة. إذا كان لديك بالفعل عروض متاحة في حسابك، فلن يتم خصم أي شيء من رصيدك. إذا نفدت العروض الخاصة بك، سيتم خصم 0.75 دولار من رصيدك في كل عرض فردي. يمكنك شراء مزيد من العروض مقدمًا وفي نفس الوقت توفير بعض المال - انتقل لأسفل للتحقق من حزم العروض.',
      bump_every: 'كل اصطدام',
      bumps_amount: 'كمية الصطدام',
      delayed_start: 'تأخير البدء',
      delayed_start_description: 'بالتحقق من هذا الخيار، سيتم تأخير الاصطدام الأول الخاص بك بالفترة المحددة من الوقت.',
    },
    bump_stop: {
      title: 'توقف التصدمات التلقائية',
      do_you_want: 'هل ترغب في إيقاف التصدمات التلقائية لهذا العنصر؟',
    },
    bulk_buy: {
      bulk_buy: 'شراء بالجملة',
      maximum_items_you_can_buy: 'أقصى عدد من العناصر التي يمكنك شراؤها بسعر محدد:',
      may_purchase_items_with_trade_hold: 'ميزة الشراء بالجملة قد تقوم بشراء العناصر مع التعليق التداولى.',
    },
  },
  affiliate: {
    ad_info: 'إذا لم ترَ الصندوق، يرجى تعطيل برنامج حظر الإعلانات.',
    affiliate_code: 'الرمز الشريك',
    affiliate_link: 'رابط الشريك',
    level: 'مستوى',
    levels: 'مستويات الشركاء',
    our_levels: 'مستوياتنا',
    your_code: '<span class="text-cp">رمز الشريك الخاص بك</span> code',
    your_affiliate_statistics: 'إحصائيات <span class="text-cp">رمز الشريك</span>',
    earn_money_by_simply_sharing: 'كسب المال عن طريق مشاركة حبك لـ BitSkins مع جمهورك!',
    percent_from_sale_fee: '٪{value} من رسوم البيع',
    join_the_bitskins_affiliate: 'انضم إلى برنامج الشراكة في BitSkins واحصل على عمولات على كل بيع يتم عبر رابط الشراكة الخاص بك. سواء كان لديك متابعة كبيرة أو عدد قليل من الأصدقاء المقربين، كلما قمت بمشاركة أكثر، كلما كسبت أكثر.',
    tile_1_title: 'شارك BitSkins مع جمهورك',
    tile_1_description: 'أنشئ رابط الشراكة الخاص بك في ثوانٍ وابدأ في مشاركته مع أصدقائك أو جمهورك.',
    tile_2_title: 'شاهد نمو أرباحك',
    tile_3_title: 'طالب بمكسبك',
    tile_3_description: 'الأموال المحصلة من برنامج الشراكة يمكن إنفاقها على شراء العناصر أو يمكن سحبها من BitSkins. الأمر متروك لك!',
    kyc_you_cannot_use: 'لا يمكنك استخدام نظام الشراكة لأنك لم تتبع إجراءات التحقق من الهوية KYC. يمكنك بدء عملية التحقق الآن.',
    your_percentage: 'نسبتك',
    generated: 'تم إنشاؤه',
    individual_affiliate_program: 'برنامج الشراكة الفردية',
    if_you_or_your_business: 'إذا كنت أنت أو عملك مشارك في صناعة الرياضات الإلكترونية أو تولد نطاقًا كبيرًا على وسائل التواصل الاجتماعي، يرجى التواصل معنا عبر partnership{\'@\'}bitskins.com. نحن قادرون على تقديم شروط شراكة فردية لك.',
    invited_referrals: 'الدعوات المدعوة',
    active_referrals: 'الدعوات النشطة',
    your_percentage_sales_fee: 'رسوم مبيعاتك بالنسبة المئوية',
    your_total_earnings: 'أرباحك الإجمالية',
    available_earnings: 'الأرباح المتاحة',
    you_can_claim_your_earnings_one_a_day: 'يمكنك المطالبة بأرباحك مرة واحدة في اليوم. بمجرد المطالبة بها، ستظهر في رصيدك المسحوب خلال 24 ساعة. الحد الأدنى للسحب هو',
    to_reach_the_next_level: 'للوصول إلى المستوى التالي وكسب عمولات أعلى، تحتاج إلى توليد <span class="text-cp">{x}</span> في المبيعات من خلال إحالاتك.',
    any_user_that_registers_from_your_affiliate_link: 'أي مستخدم يقوم بالتسجيل من خلال رابط الشراكة الخاص بك سيتم تعيينه تلقائيًا كحكم لك',
    my_earnings: 'أرباحي',
    referred_users: 'المستخدمون المشار إليهم',
    code_updated: 'تم تحديث رمز الشريك بنجاح',
    not_enough_money: 'لا يوجد ما يكفي من المال للتحويل',
    account: 'حساب',
    referrals_sales: 'تاريخ مبيعات الدعوات',
  },
  profile: {
    hi: 'مرحبا',
    nav: {
      account: 'حساب',
      wallet: 'محفظة',
      transactions: 'المعاملات',
      statistics: 'الإحصاءات',
      affiliate: 'شريك تابع',
      company: 'شركة',
      trades: 'الصفقات',
      items_history: 'تاريخ العناصر',
    },
    top_star: {
      you_are: 'أنت',
      top_star: 'نجم أعلى',
      good_to_see_you: 'مرحبًا "{username}", إنه جيد جدًا أن أراك على BitSkins!',
      appreciate_using: 'نحن نقدر أنك قررت استخدام منصتنا،',
      extra_settings: 'لذلك قمنا بإعداد بعض الإعدادات الإضافية لك.',
      show_nickname_selling: 'أظهر اسمي المستعار على صفحة العنصر أثناء البيع',
      show_nickname_store: 'أبرز اسمي المستعار على صفحة المتجر',
    },
    basic: {
      basic_information: 'معلومات أساسية',
      username: 'اسم المستخدم',
      change_username: 'تغيير اسم المستخدم',
      registration_date: 'تاريخ التسجيل',
      email: 'البريد الإلكتروني',
      change_email: 'تغيير البريد الإلكتروني',
      password: 'كلمة المرور',
      change_password: 'تغيير كلمة المرور',
      phone: 'رقم الهاتف',
      change_phone: 'تغيير الهاتف',
      hide_balance: 'أخفِ رصيدك',
      hide_balance_description: 'سيتم إخفاء مبلغ الأموال من الرأس، وسيظل مرئيًا بعد الضغط على المحفظة.',
    },
    security: {
      you_can_access_your_account: 'يمكنك الوصول إلى حسابك من خلال مفتاح API . توجد وثائق API  الخاصة بنا في الموقع',
      api_status: 'حالة API ',
      security: 'الأمان',
      twofa: 'المصادقة الثنائية',
      temporarily_block_my_account: 'قم بحظر حسابي مؤقتًا',
      temporarily_block_title: 'مؤقتاً <span class="text-cr">تم حظر حسابي</span>',
      temporarily_block_description: 'إذا كنت تعتقد أن حسابك قد تم اختراقه، يمكنك حظره مؤقتًا.\nسنقوم بإلغاء حظر حسابك بعد التواصل مع دعمنا.',
      temp_blocked: 'تم حظر حسابك مؤقتًا.\nيرجى التواصل مع دعمنا لتوضيح الوضع.',
      block_my_account: 'قم بحظر حسابي',
      delete_account: 'حذف الحساب',
      delete_my_account: 'حذف حسابي',
      sessions: 'جلسات',
      close_all_sessions: 'أغلق جميع الجلسات',
      current_session: 'الجلسة الحالية',
      active_sessions: 'جلسات نشطة',
      no_other_sessions: 'لا توجد جلسات أخرى',
      removed: 'تمت الإزالة',
      online: 'عبر الإنترنت',
      api_key: 'مفتاح API',
      api_key_not_available: 'يتم رؤية مفتاح API فقط مرة واحدة أثناء إنشائه',
      sensitive_hidden: 'معلومات حساسة مخفية',
      ip_whitelist: 'قائمة IP البيضاء',
      add_ip_to_whitelist: 'أضف عنوان IP إلى القائمة البيضاء',
      disable_api_confirm: 'تأكيد تعطيل الوصول إلى API',
      disable_api_content: 'هل أنت متأكد أنك تريد تعطيل وصول API لحسابك؟',
    },
    store: {
      my_store: 'متجري',
      store: 'متجر',
      store_url: 'رابط المتجر',
      store_alias: 'اسم المتجر',
      id_store: 'هوية المتجر',
      hide_store: 'أخفِ صفحة متجرك',
      url_copied: 'تم نسخ رابط المتجر',
      total_items: 'عدد العناصر الكلية.',
      games: 'ألعاب',
    },
    setting: {
      account_email: 'حساب البريد الإلكتروني',
      update_email: 'تحديث البريد الإلكتروني',
      setup_email: 'إعداد البريد الإلكتروني',
      update_password: 'تحديث كلمة المرور',
      set_password: 'تعيين كلمة المرور',
      enter_current_password: 'أدخل كلمة المرور الحالية',
      password_changed: 'تم تغيير كلمة المرور',
      current_password: 'كلمة المرور الحالية',
      enter_new_password: 'أدخل كلمة مرور جديدة',
      repeat_new_password: 'كرر كلمة المرور الجديدة',
      save_new_password: 'حفظ كلمة المرور الجديدة',
      new_password: 'كلمة مرور جديدة',
      repeat_password: 'كرر كلمة المرور',
      account_2fa: 'حساب 2FA',
      enable_2fa: 'تشغيل 2FA',
      disable_2fa: 'تعطيل 2FA',
    },
    transaction: {
      amount: 'المبلغ',
      type: 'نوع',
      details: 'تفاصيل',
      fee: 'مصاريف',
      buyer_country: 'بلد المشتري',
      seller_country: 'بلد البائع',
      price: 'السعر',
      item_name: 'اسم العنصر',
      transaction_history: 'سجل المعاملات',
      operation: 'العملية',
      trade_id: 'معرّف التداول',
      loading_trade_offers: 'فتح عرض التداول',
      no_trades_found: 'لا توجد عروض تداولية متاحة',
      id: 'بطاقة تعريف',
      date: 'تاريخ',
      game: 'لعبة',
      items: 'العناصر',
      status: 'الحالة',
      time_left: 'الوقت المتبقي',
      action: 'عمل',
      trades_active: 'التداولات نشطة',
      trades_history: 'تاريخ التداول',
      balance: 'التوازن',
      history: 'سجل المعاملات',
      pending: 'المعاملات المعلقة',
      reports: 'تصدير التقارير',
      active_locks: 'الأقفال النشطة',
      export: 'تصدير',
      export_to_csv: 'تصدير إلى .CSV',
      export_description: 'حدد الشهر والسنة التي ترغب في إنشاء التقرير الخاص بها.',
      the_report_will_appear_in_the: 'سيظهر التقرير في',
      tab_once_the_export_process_is_complete: 'اضغط على علامة التبويب بمجرد اكتمال عملية التصدير.',
    },
  },
  fee: {
    individual: 'فرد',
    individual_fee: 'رسوم فردية',
    custom_sale_fee: 'رسوم البيع المخصصة الخاصة بك',
    your_current_fees: 'رسومك الحالية',
    high_tier: 'عالي المستوى',
    fee: 'رسوم',
    fee_up_to: 'رسوم',
    sale_fee: 'رسوم البيع',
    sales_fees: 'رسوم البيع',
    see_all_levels: 'انظر إلى جميع المستويات',
    you_are_on_the: 'أنت على',
    maximum_sales_fee: 'أقصى رسوم مبيعات: {value}',
    your_total_sale_volume: 'حجم مبيعاتك الإجمالي حتى الآن هو',
    sales_fees_will_be_lowered: 'سيتم خفض رسوم البيع كلما قمت ببيع المزيد من العناصر.',
    level: 'مستوى',
    your_level: 'مستواك:',
    progress: 'التقدم:',
    max_level: 'مستوى ماكس',
    next_level: 'المستوى التالي',
    total_income: 'الدخل الإجمالي',
    total_revenue: 'إجمالي الإيرادات',
    sold_items: 'العناصر المباعة',
    page: {
      sales_fees_depends_on_two_factors: 'على BitSkins، تعتمد "رسوم البيع" على عاملين.',
      the_price: '1. السعر الذي تبيع به العنصر الخاص بك',
      the_listing_type: '2. نوع القائمة:',
      listing_type_public: 'عام - يمكن رؤية عنصرك من قبل جميع المستخدمين على الموقع',
      listing_type_private: 'خاص - العنصر الخاص بك مرئي فقط للأشخاص الذين تشاركهم الرابط',
      fee_explanation: 'كلما زاد سعر بيع العنصر الخاص بك، زادت رسوم البيع المطلوبة. تتراوح رسوم البيع القياسية من 2.5٪ (للقوائم الخاصة) إلى حد أقصى 10٪ (للقوائم العامة). بالإضافة إلى ذلك، لدينا 5 مستويات مبيعات مختلفة تسمح لك بتخفيض رسوم البيع الخاصة بك بشكل أكبر. القاعدة بسيطة - كلما قمت ببيع أكثر، كلما قمت بدفع رسوم بيع أقل. يمكنك تخفيض رسوم البيع الخاصة بك حتى 2.4٪ (للقوائم الخاصة) أو حتى 9.8٪ (للقوائم العامة). نظام الرسوم لدينا شفاف ولا توجد رسوم مخفية.',
      default_sales_fees_title: 'رسوم البيع الافتراضية',
      default_sale_fees_description: 'إذا كنت تبدأ للتو ولم تبيع أي عناصر بعد ، فسيكون رسوم المبيعات الخاصة بك على النحو التالي:',
      how_to_reduce_my_sales_fees_title: 'كيف يمكنني تقليل رسوم البيع الخاصة بي؟',
      how_to_reduce_my_sales_fees_description: 'على BitSkins لدينا 5 مستويات مبيعات. يقلل كل منها (باستثناء المستوى 1) من رسوم البيع بنسبة 0.05%. لترقية مستواك، تحتاج إلى بيع العناصر بنطاق سعر معين.',
      sales_fees_levels: 'مستويات رسوم المبيعات',
      price_range: 'نطاق الأسعار',
      total_sales: 'إجمالي المبيعات',
      fee_reduced_by: 'تم تخفيض الرسوم بواسطة',
      individual_sales_fees_title: 'رسوم المبيعات الفردية',
      individual_sales_fees_description: 'إذا كنت تستخدم BitSkins بنشاط وإجمالي دورانك الشهري على الأقل <span class="span text-csfl6">{amount}</span>، فلا تتردد في التواصل معنا. يمكننا أن نقدم لك رسوم بيع أقل ومساعدة إضافية.',
    },
  },
  copy: {
    text_copied: 'نص تم نسخه',
    cannot_copy: 'لا يمكن نسخه',
    name_copied: 'اسم تم نسخه',
    cannot_copy_name: 'لا يمكن نسخ الاسم',
    copy_link: 'نسخ الرابط',
  },
  share: {
    share_on_twitter: 'شارك على Twitter',
    share_on_facebook: 'شارك على Facebook',
    share_on_telegram: 'شارك على Telegram',
  },
  discord: {
    discord: 'Discord',
    already_connected: 'متصل بالفعل',
    something_went_wrong: 'شيء ما حدث خطأ',
    success: 'نجاح!',
    loading: 'تحميل...',
    connect_with_discord: 'قم بالاتصال مع Discord',
  },
  telegram: {
    already_connected: 'متصل بالفعل',
    something_went_wrong: 'شيء ما حدث خطأ',
    success: 'نجاح!',
    loading: 'تحميل...',
  },
  error: {
    error_404: 'خطأ 404',
    page_not_found: 'الصفحة غير موجودة',
  },
  kyc: {
    description_1: 'لضمان أمان المعاملات التي تتم عبر موقعنا والامتثال للوائح AML/KYC المعمول بها، نحتاج منك إجراء عملية التحقق من البيانات (KYC). هناك ثلاثة مستويات للتحقق. يزيد كل من المستويات أو يزيل الحدود تمامًا ويمنحك الوصول إلى طرق دفع جديدة.',
    description_2_start: 'تم وصف التفاصيل الدقيقة والشروط المتعلقة بعملية التحقق من KYC في شروط الخدمة الخاصة بنا. نود أن نؤكد لكم أن جميع البيانات التي تقدمونها ستستخدم وفقًا للشروط والأحكام.',
    description_2_end: 'بتشغيل عملية التحقق من KYC ، فإنك توافق على معالجة بياناتك من قبلنا للأغراض المبررة قانونيًا.',
    personal_data: 'البيانات الشخصية',
    first_name: 'الاسم الأول',
    middle_name: 'الاسم الأوسط',
    last_name: 'الاسم الأخير',
    street_name: 'اسم الشارع',
    street_number: 'رقم الشارع',
    postal_code: 'الرمز البريدي',
    city: 'مدينة',
    province: 'محافظة',
    country: 'البلد',
    start_kyc_verification: 'ابدأ التحقق من KYC',
    upload: 'تحميل',
    uploaded: 'تم تحميله',
    image_uploaded: 'تم تحميل الصورة',
    document_type: {
      id: 'معرف',
      driving_license: 'رخصة القيادة',
      passport: 'جواز السفر',
      other: 'أخرى',
    },
    limit: {
      crypto_withdraw: 'الحد السنوي لسحب العملات Crypto هو {amount}',
      crypto_withdraw_unlimited: 'سحب العملات Crypto غير محدودة',
      non_crypto_withdraw: 'الحد السنوي للسحب غير Crypto لـ {amount}',
      non_crypto_withdraw_unlimited: 'غير محدود السحب غير Crypto',
      crypto_deposit: 'الحد السنوي للإيداعات الرقمية للعملات Crypto هو {amount}',
      crypto_deposit_unlimited: 'إيداعات العملات Crypto غير محدودة',
      non_crypto_deposit: 'الحد السنوي للإيداعات غير Crypto هو {amount}',
      non_crypto_deposit_unlimited: 'غير محدود الودائع غير Crypto',
    },
    your_kyc_verification: 'تحقق KYC الخاص بك',
    your_kyc_needs_an_update: 'تحتاج إلى تحديث KYC الخاص بك.',
    need_update_reason: 'للأسف لم نتمكن من الموافقة على حسابك بسبب الأسباب التالية:',
    open_support: 'فتح الدعم',
    your_kyc_has_been_denied: 'تم رفض KYC الخاص بك',
    denied_description: 'تم رفض KYC الخاص بك، لذلك لا يمكنك إجراء التحقق من KYC مرة أخرى.',
    deleted_description: 'تم رفض KYC الخاص بك. يمكنك المرور من خلال عملية التحقق مرة أخرى.',
    please_contact_our: 'يرجى الاتصال بنا',
    support: 'دعم',
    clarify_the_situation: 'لتوضيح الوضع.',
    your: 'الخاصة بك',
    kyc_title: 'تعرف على عميلك التحقق',
    verification: 'التحقق',
    pending: 'قيد الانتظار',
    pending_description: 'هذا كل شيء! شكراً لك على اجتياز عملية التحقق. تم تقديم بياناتك بنجاح. سنبذل قصارى جهدنا لفحص طلبك في أقرب وقت ممكن. عادةً ما يستغرق ذلك لا يزيد عن 12 ساعة. سنرسل لك رسالة عبر البريد الإلكتروني بمجرد الموافقة على حسابك. نحن نقدر صبرك.',
    do_you_need_help: 'هل تحتاج إلى مساعدة؟ يرجى التواصل معنا',
    support_center: 'مركز الدعم',
    back_to_kyc: 'العودة إلى KYC',
    go_to_home: 'اذهب إلى المنزل',
    level_0: 'مستوى 0',
    level_1: 'المستوى 1',
    level_2: 'المستوى 2',
    limits: 'الحدود',
    benefits: 'الفوائد',
    requirements: 'المتطلبات',
    no_requirements: 'لا توجد متطلبات',
    proof_of_address: 'إثبات العنوان',
    all_benefits_from_the_basic_level: 'جميع الفوائد من المستوى الأساسي',
    personal_information: 'معلومات شخصية',
    identity_document: 'وثيقة الهوية',
    selfie: 'سيلفي',
    all_benefits_from_level_1: 'جميع الفوائد من المستوى 1',
    current: 'الحالي',
    upending: 'قيد التنفيذ',
    update: 'تحديث',
    verification_blocked: 'تم حظر التحقق',
    verify_now: 'تحقق الآن',
    you_need_to_upgrade_to_level_1: 'تحتاج إلى الترقية إلى المستوى 1',
    upgrade_to_level_1: 'ترقية إلى المستوى 1',
    upgrade_to_level_2: 'ترقية إلى المستوى 2',
    kyc_verification: 'التحقق من KYC',
    kyc_verification_span: 'التحقق من KYC',
    kyc_verification_required: 'التحقق من KYC مطلوب',
    everything_done: 'كل شيء تم!',
    proof_of_residency: 'إثبات الإقامة',
    you_current_residential_address: 'عنوان إقامتك الحالي',
    only_x_minutes: 'فقط {minutes} دقائق!',
    identity_verification: 'التحقق من الهوية',
    take_a_selfie: 'خذ صورة سيلفي',
    step: 'الخطوة {step}',
    country_of_residence: 'بلد الإقامة',
    full_name: 'الاسم الكامل',
    date_of_birth: 'تاريخ الميلاد',
    nationality: 'الجنسية',
    choose_your_document: 'اختر مستندك',
    choose_document_description_1: 'اختر المستند الذي ترغب في استخدامه أثناء التحقق.',
    choose_document_description_2: 'نحن نقبل فقط المستندات الصادرة عن الحكومة الصالحة.',
    choose_document_description_3: 'أي وثائق أخرى غير مدرجة في القائمة ستُرفض.',
    document_number: 'رقم الوثيقة',
    country_of_issue: 'بلد الإصدار',
    document_issue_date: 'تاريخ إصدار المستند',
    document_expiry_date: 'تاريخ انتهاء الوثيقة',
    files_requirements: 'متطلبات الملفات',
    format: '{format} أو {or} format',
    maximum_file_size: 'أقصى حجم للملف {size}',
    minimum_picture_size: 'الحد الأدنى لحجم الصورة {size} بكسل',
    not_accepted_documents: 'ليس لديهم وثائق مقبولة',
    expired: 'منتهية الصلاحية',
    edited: 'تم التعديل',
    black_and_white: 'أسود وأبيض',
    broken_or_damaged: 'مكسورة أو تالفة',
    illegible_blurred_or_reflective: 'غير مقروءة، غير واضحة أو معكوسة',
    cut_off_or_overcropped: 'قطع أو تجاوز الحد',
    upload_front_page: 'تحميل الصفحة الأمامية',
    upload_back_page: 'رفع الصفحة الخلفية',
    selfie_description: 'يرجى تحميل صورة لنفسك وأنت تحمل هويتك وورقة تحمل اسمك ونص "BitSkins.com" وتاريخ اليوم.',
    example_of_correctly_taken_photo: 'مثال على صورة ملتقطة بشكل صحيح',
    with_sunglasses_cap_or_mask: 'مع النظارات الشمسية، الكاب أو القناع',
    information_covered_by_finger: 'معلومات عن وثيقتك مغطاة بأصابعك',
    face_covered_by_document: 'وجهك مغطى بواسطة وثيقتك',
    out_of_focus: 'وجهك أو وثيقتك خارج التركيز',
    upload_selfie: 'تحميل صورة شخصية',
    send_level_1_kyc_request: 'أرسل طلب KYC المستوى 1',
    address_line_1: 'العنوان الأول',
    address_line_2_optional: 'السطر الثاني من العنوان (اختياري)',
    state_or_province: 'الدولة أو المقاطعة',
    proof_of_residency_description: 'يرجى تحميل وثيقة تثبت عنوان إقامتك الحالي الذي قدمته في الخطوة السابقة. تأكد من أن اسمك الكامل مرئي على الوثيقة.',
    upload_document: 'تحميل المستند',
    accepted_documents: 'المستندات المقبولة',
    utility_bills: 'فواتير المرافق',
    bank_statements: 'كشف حسابات بنكية',
    tax_returns: 'إقرارات الضرائب',
    government_letters: 'رسائل الحكومة',
    other_document_residential: 'وثائق أخرى تؤكد عنوان إقامتك الحالي',
    send_level_2_kyc_request: 'أرسل طلب KYC من المستوى 2',
    submit: 'قدم',
    submit_correct: 'أرسل المعلومات الصحيحة',
    next: 'التالي',
    send_to_verify: 'أرسل للتحقق',
    document_verification: 'التحقق من الوثيقة',
    level: 'مستوى KYC',
    please_reupload_following_photos: 'يرجى إعادة تحميل الصور التالية',
    please_reupload: 'من فضلك قم بإعادة التحميل',
    we_need_additional_information: 'نحتاج إلى معلومات إضافية',
    file_format_not_supported: 'هذا النوع من الملف غير مدعوم.',
    the_file_is_too_big: 'الملف {file_name} كبير جدًا ({file_size})،<br> الحد الأقصى {size_limit}.',
    field: {
      document_image_a: 'الصفحة الأولى من وثيقتك',
      document_image_b: 'الصفحة الخلفية من وثيقتك',
      user_image: 'صورتك الشخصية',
      address_image: 'إثبات الإقامة',
      additional_selfie: 'صورة شخصية إضافية',
    },
    back_to_bitskins: 'العودة إلى BitSkins',
    withdrawals: 'سحب الأموال',
    get_to_the_next_level: 'الوصول إلى المستوى التالي للتخلص من القيود والحصول على وصول إلى طرق الدفع الجديدة.',
    after_the_first_page_is_validated: 'بعد التحقق من الصورة الأولى، ستتمكن من رفع الصفحة الثانية.',
    accepted: 'قبلت',
  },
  camera: {
    cancel: 'إلغاء',
    check_permissions: 'تحقق من الأذونات',
    take_a_new_photo: 'التقط صورة جديدة',
    take_a_photo: 'التقط صورة',
    use_camera: 'استخدم الكاميرا',
    use_photo: 'استخدم الصورة',
    we_will_need_access_to_your_camera: 'سنحتاج إلى الوصول إلى كاميراك لكي نتمكن من المتابعة.',
    please_follow_these_steps: 'يرجى اتباع هذه الخطوات',
    select_the_camera_icon: 'حدد أيقونة الكاميرا في شريط العناوين الخاص بك',
    select_always_allow_access: 'حدد "السماح دائمًا بالوصول إلى الكاميرا"',
    select_done: 'اختر <strong>تم</strong>',
  },
  review: {
    leave_a_review: 'اترك تقييما',
    our_reviews: 'مراجعاتنا',
    if_youre_happy: 'إذا كنت سعيدًا بالخدمة،',
    we_would_appreciate: 'نحن سنقدر إذا تركت لنا مراجعة على Trustpilot تشاركنا تجربتك لمساعدتنا. شكرًا لك!',
    if_youre_happy_we_would_appreciate: 'إذا كنت سعيدًا بالخدمة، فسنقدر إذا تركت لنا مراجعة على Trustpilot تشارك فيها تجربتك لمساعدتنا. شكرًا لك!',
  },
  support: {
    center: 'مركز الدعم',
    tickets_list: 'قائمة التذاكر',
    create_ticket: 'إنشاء تذكرة',
    submit_ticket: 'قدم تذكرة',
    close_ticket: 'أغلق التذكرة',
    submit_disclaimer: 'لتسريع عملنا وتلقي الرد في أقرب وقت ممكن، تأكد من عدم فتح تذاكر متعددة تتعلق بنفس المشكلة. متوسط وقت الاستجابة هو عدة ساعات. يمكنك التواصل معنا باللغة الإنجليزية والبولندية والسويدية. شكرًا لتعاونك.',
    enter_your_message: 'أدخل رسالتك',
    new_ticket: 'تذكرة جديدة',
    your_ticket: 'تذكرتك',
    bitskins_team: 'فريق BitSkins',
    ticket_has_been_closed_by: 'تم إغلاق التذكرة بواسطة {by}',
    ticket_has_been_closed: 'تم إغلاق التذكرة',
    conversation_history: 'سجل المحادثة:',
    your_reply: 'ردك...',
    last_reply_by: 'آخر رد بواسطة',
    send: 'إرسال',
    ticket: 'تذكرة',
    title: 'عنوان',
    category: {
      payments: 'المدفوعات',
      payment_crypto_deposit: 'إيداع العملة Crypto',
      payment_crypto_withdraw: 'سحب العملات Crypto',
      payment_standard_deposit: 'طريقة الإيداع القياسية',
      payment_standard_withdraw: 'طريقة السحب القياسية',
      market: 'السوق',
      market_item_issue: 'مشكلة العنصر',
      market_buy_orders: 'أمر الشراء',
      market_bulk_buy: 'شراء بالجملة',
      market_missing_screenshot: 'التقاطة المفقودة',
      market_missing_float: 'مفقود float',
      market_wrong_price: 'سعر Steam خاطئ',
      market_other: 'أخرى',
      trading: 'الصفقات',
      trading_deposit: 'إيداع العنصر',
      trading_withdraw: 'سحب العنصر',
      account: 'حساب',
      account_2fa: 'مشكلة 2FA',
      account_email: 'مشكلة البريد الإلكتروني',
      account_kyc: 'KYC',
      account_affiliate: 'نظام الشراكة',
      account_restrictions: 'القيود',
      account_other: 'أخرى',
      other: 'أخرى',
      bug_report: 'تقرير الخلل',
      api: 'واجهة برمجة التطبيقات',
      suggestions: 'اقتراحات',
      business_inquiry: 'استفسار تجاري',
      general_inquiry: 'استفسار عام',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'المبلغ',
      crypto: 'عملة Crypto',
      disclaimer_visa_1: 'يرجى أخذ في الاعتبار أنه من الطبيعي أن يستغرق حتى 5 أيام عمل قبل أن يتوفر المال في حسابك المصرفي.',
      disclaimer_visa_2: 'يرجى التأكد من أنها بطاقة فيزا وليس بطاقة ماستركارد التي تحاول سحب الأموال منها. نحن لا ندعم حاليًا سحب الأموال باستخدام بطاقات ماستركارد.',
      card_digits: '4 أرقام آخرى من بطاقتك',
      binance_id: 'معرف Binance الخاص بك',
      wallet_address: 'عنوان المحفظة',
      provider: 'مزود',
      transaction_id: 'معرف المعاملة',
      type: 'نوع',
      method: 'طريقة',
      item_link: 'رابط إلى العنصر',
      bot_received_item: 'رابط ملف تعريف البوت الخاص بك على Steam الذي استلم عناصرك',
      trade_offer_id: 'معرف عرض التداول',
      can_be_found_here: 'يمكن العثور عليها هنا',
      email: 'أدخل البريد الإلكتروني',
    },
  },
  service: {
    market: {
      buy: 'شراء',
      sell: 'بيع',
      fee: 'رسوم البيع',
      buy_order: 'أمر الشراء',
      bargain: 'تفاوض',
      instant_sell: 'بيع فوري',
      bump: 'رفع ',
      bump_package: 'رفع الرزمة',
    },
    deposit: {
      gift_code: 'رمز الهدية',
      bitcoin: 'إيداع BTC',
      litecoin: 'إيداع LTC',
      ethereum: 'إيداع ETH',
      unlimint: 'إيداع باستخدام بطاقة البنك',
      binance_pay: 'إيداع باستخدام Binance Pay',
      binancepay: 'إيداع باستخدام Binance Pay',
      available_coupons: 'الكوبونات المتاحة',
      redeem_coupon: 'استبدل الكوبون',
      enter_coupon_code: 'أدخل الكوبون',
      open_binance_website: 'افتح موقع Binance',
      list_of_active_transactions: 'قائمة المعاملات النشطة',
      transaction_needs_at_least_x_confirmations: 'تحتاج العملية إلى ما لا يقل عن {x} تأكيد قبل ظهور الأموال في حسابك.',
      billing_information: 'معلومات الفوترة',
      coupon: {
        coupon: 'كوبون',
        make_a_gift: 'اصنع لنفسك أو لشخص آخر هدية',
        bitskins_coupons_are_a_good_alternative: 'قسائم BitSkins هي بديل جيد لوسائل الدفع القياسية وفكرة هدية رائعة. يمكنك شراؤها من شركائنا الذين يقدمون العديد من وسائل الدفع.',
        dont_wait: 'لا تنتظر وقم بشحن رصيدك باستخدام قسيمة BitSkins أو قم بإهداء شخص ما هدية أصلية (نحن جميعًا نعرف شخصًا لديه مخزون فارغ).',
        kinguin: 'Kinguin (رسوم مخفضة جديدة)',
      },
      crypto: {
        get_wallet_address: 'احصل على عنوان المحفظة',
        your_wallet_address: 'عنوان محفظتك',
        this_address_is_only_for_x: 'هذا العنوان مخصص فقط للإيداعات {x}. لا ترسل أي عملة رقمية أخرى إلى هذا العنوان.',
        this_address_will_not_expire: 'هذا العنوان لن ينتهي. يمكنك استخدامه في أي وقت.',
        choose_alternative_address: 'اختر عنوان بديل',
        the_acutal_amount_you_will_be_credited: 'المبلغ الفعلي الذي ستحصل عليه يعتمد على سعر {x} في الوقت الذي نتلقى فيه دفعتك.',
        only_l1_transactions: 'فقط المعاملات L1 مدعومة. لا تستخدم المعاملات الداخلية والعقود الذكية!',
      },
      zen: {
        zen: 'إيداع مع ZEN',
        deposit_started: 'بدأ إيداع ZEN',
        open_the_zen_deposit_page: 'افتح صفحة إيداع ZEN',
        processing_fee: 'سيقوم ZEN بإضافة رسوم معالجة إلى العملية التي تعتمد على طريقة الدفع المحددة. سيكون مبلغ العملية النهائي مرئيًا على موقعهم الإلكتروني.',
        each_transaction_is_reviewed: 'كل عملية يتم مراجعتها من قبل ZEN Pay وقد تستغرق بين دقيقة وعدة ساعات لإكمالها.',
      },
      the_minimum_deposit_amount_is: 'الحد الأدنى لمبلغ الإيداع هو {amount}.',
      the_maximum_deposit_amount_is: 'الحد الأقصى لمبلغ الإيداع هو {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: 'نحن نقدم المدفوعات فقط لموقع binance.com (binance.us غير مدعوم).',
      bitcoin: 'سحب BTC',
      litecoin: 'سحب LTC',
      ethereum: 'سحب ETH',
      unlimint: 'انسحب إلى بطاقة فيزا',
      tipalti: {
        tipalti: 'انسحب باستخدام Tipalti',
        tipalti_allows_you_to_withdraw: 'تسمح لك Tipalti بسحب أموالك إلى حسابك المصرفي وحساب PayPal الخاص بك.',
        you_dont_have_a_tipalti_acount: 'أليس لديك حساب في Tipalti؟',
        you_have_to_create_an_account: 'لسحب أموالك من خلال Tipalti ، يجب عليك أولاً إنشاء حساب على موقعهم. <br> يمكنك القيام بذلك عن طريق النقر على الزر أدناه.',
        create_tipalti_account: 'إنشاء حساب Tipalti',
        check_your_email: 'يرجى التحقق من صندوق البريد الوارد الخاص بك والنقر على رابط التأكيد لإكمال عملية إنشاء الحساب. إذا لم تتمكن من العثور على رسالة البريد الإلكتروني في صندوق الوارد الخاص بك، يرجى التحقق من مجلد البريد العشوائي الخاص بك.',
        payment_method: 'طريقة الدفع',
        tipalti_panel: 'لوحة Tipalti ',
        tipalti_payouts_incur_a_fee: 'تتكبد عمليات الدفع من خلال Tipalti رسومًا يمكن أن تصل إلى 26 دولارًا. تعتمد الرسوم على طريقة الدفع المحددة. فيما يلي يمكنك العثور على جدول يحتوي على الرسوم لكل طريقة دفع.',
        fee_per_payment: 'رسوم لكل دفعة',
        rejection_fee: 'رسوم الرفض',
        echeck_local: 'eCheck (محلي)',
        paypal_non_us: 'PayPal (غير مقيم في الولايات المتحدة)',
        paypal_us: 'PayPal (مقيم في الولايات المتحدة)',
        wire_transfer_non_us_non_usd: 'تحويل سلكي (لغير المقيمين في الولايات المتحدة والمدفوع بعملة غير الدولار الأمريكي)',
        wire_transfer_non_us_usd: 'تحويل سلكي (لغير المقيمين في الولايات المتحدة والمدفوع بالدولار الأمريكي)',
        wire_transfer_us: 'تحويل سلكي (مقيم في الولايات المتحدة)',
        up_to_21_usd: 'حتى 21.00 دولار',
        up_to_2_usd: 'حتى 2.00 دولار',
      },
      payoneer: 'اسحب باستخدام Payoneer',
      binance_pay: 'اسحب باستخدام Binance Pay',
      binancepay: 'اسحب باستخدام Binance Pay',
      p2p: 'نقل P2P',
      payouts_are_performed_on_a_rolling_basis: 'يتم تنفيذ الدفعات على أساس متداول حتى 5 دقائق بعد طلبها.',
      your_payout_will_be_processed_at_the_current_rate: 'سيتم معالجة مدفوعاتك بسعر الصرف الحالي.',
      please_verify_the_wallet_address: 'يرجى التحقق من عنوان المحفظة. لا يمكننا استرداد سحب غير صحيح.',
      the_data_controller: 'يكون متحكم البيانات والطرف المتعاقد مع Unlimint فيما يتعلق بالمدفوعات التي يتم معالجتها من قبلهم هو BitSkins Sp. z o.o. بمقرها المسجل 40-246 كاتوفيتشي، شارع بورسلانوفا 23، بولندا، مسجلة تحت الرقم: 0000810143 - يمكن العثور على مزيد من التفاصيل في سياسة الخصوصية وشروط الاستخدام.',
      visa_withdrawals_are_processed_instantly: 'يتم معالجة سحب الفيزا على الفور. ومع ذلك، في بعض الحالات قد يستغرق الأمر عدة أيام قبل أن تظهر الأموال في حسابك البنكي.',
      card_info: 'معلومات البطاقة',
      ccv: 'CCV',
      add_new_deposit_needed: 'أضف جديد (الوديعة المطلوبة)',
      you_can_have_max_3_bank_cards: 'يمكنك الحصول على حد أقصى من ثلاث بطاقات بنكية مرتبطة بحسابك.',
      your_cards_amount: '<span class="text-cp">بطاقاتك</span> ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'الحد الأدنى للمبلغ المسموح بسحبه هو {x}.',
      the_maximum_withdraw_amount_is_x: 'الحد الأقصى للمبلغ المسموح بسحبه هو {x}.',
      enter_amount: 'أدخل المبلغ',
      go_to_card_deposit: 'اذهب إلى إيداع البطاقة',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'لكي تتمكن من سحب أموالك، تحتاج إلى التحقق من بطاقتك أولاً. يمكنك القيام بذلك عن طريق إيداع 1 دولار.',
      deposited_funds_are_non_withdrawable: 'يرجى أن تضع في اعتبارك أن الأموال المودعة غير قابلة للسحب ويمكن استخدامها فقط للشراء.',
      we_do_not_support_mastercard_withdrawals: 'لا ندعم سحب الأموال إلى بطاقات ماستركارد وإلى البطاقات الصادرة في البلدان التالية: البوسنة والهرسك، كندا، مصر، اليابان، كمبوديا، كوريا (جمهورية كوريا)، كوسوفو، مقدونيا الشمالية، الولايات المتحدة الأمريكية، الأرجنتين.',
      your_card_is_valid_until: 'بطاقتك صالحة حتى 16.02.2023، الساعة 15:35 (توقيت عالمي منسق). بعد هذا الوقت، سيتعين عليك إعادة التحقق من بطاقتك عن طريق إيداع 5 دولارات.',
      card_verification_required: 'التحقق من البطاقة مطلوب',
      card: 'بطاقة',
      add_new_card: 'إضافة بطاقة جديدة',
      how_to_find_my_binance_id: 'كيفية العثور على معرف المستخدم الخاص بي (BUID) على Binance؟',
      how_to_find_my_pay_id: 'كيفية العثور على معرف الدفع الخاص بي على Binance؟',
      how_to_find_my_email: 'كيفية العثور على بريدي الإلكتروني على Binance؟',
      binance_id: 'رقم حساب Binance',
      receiver_type: 'نوع المستقبل',
      i_do_not_have_a_binance_account: 'أنا لا أملك حسابًا في Binance',
      i_have_a_binance_account: 'لدي حساب في Binance',
      binance_account: 'حساب Binance',
      the_fee_is_already_included_in_the_current_x_rate: 'الرسم {fee}% مضمن بالفعل في السعر الحالي {x}.',
    },
    wallet: {
      transfer: 'تحويل الأموال',
      refund: 'استرداد الأموال',
      available_payment_methods: 'طرق الدفع المتاحة',
      bank_cards: 'بطاقات البنك',
      kyc_required_for_this_payment_method: 'لا يمكنك استخدام طريقة الدفع هذه لأنك لم تتبع إجراءات KYC. يمكنك بدء عملية التحقق الآن.',
      kyc_limit_exceeded: 'لا يمكنك استخدام طريقة الدفع هذه لأنك تجاوزت الحد المسموح به للمعاملات لمستوى التحقق الخاص بك. يمكنك الآن بدء عملية التحقق لإزالة القيود.',
      no_limit: 'لا حدود',
      limits_info: 'على BitSkins، لكل عملية تجارية مؤقت وحدودها الخاصة تعيد ضبطها بعد مرور عام على إجراء العملية. يتم عرض الحد الأقصى للمبالغ التي يمكنك إيداعها أو سحبها في الرسوم البيانية. يمكنك زيادة الحدود أو التخلص تمامًا منها عن طريق إجراء إجراء KYC.',
      crypto_deposits: 'إيداعات العملات كريبتو',
      crypto_withdrawals: 'سحب العملات كريبتو',
      standard_deposits: 'الودائع القياسية',
      standard_withdrawals: 'السحب القياسي',
      coupons_are_excluded_from_the_limit: '* يتم استبعاد كوبون من الحد المسموح به',
      x_type_does_not_incur_any_fees: '{x} {type} لا تتحمل أي رسوم.',
      incur_fees_of: 'تتحمل رسوماً قدرها',
      plus: 'بالإضافة إلى',
      the_minimum_type_amount_is: 'الحد الأدنى {type} للمبلغ هو',
      the_maximum_type_amount_is: 'الحد الأقصى{type} للمبلغ هو',
      due_to_unstable_crypto_network: 'بسبب شبكة كريبتو المشفرة غير المستقرة ، قد تواجه بعض التأخيرات.',
      binance_temporarily_disabled: 'تم تعطيل سحب Binance حتى يوم الاثنين (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'رصيد حساب',
      sell: 'تم البيع',
      buy: 'اشترى',
    },
    report_status: {
      empty: 'فارغ',
      pending: 'قيد التنفيذ',
      done: 'تمت العملية',
    },
    autobump_period: {
      hour_1: 'ساعة',
      hour_3: '3ساعات',
      hour_6: '6ساعات',
      hour_12: '12ساعة',
      hour_24: '24ساعة',
      hour_48: '48ساعة',
    },
    autobump_status: {
      not_enough_bumps: 'ليس هناك ما يكفي من الرفع ',
      finished: 'تم الانتهاء',
      cancelled: 'تم الإلغاء',
      pending: 'قيد الانتظار',
      active: 'نشيط',
    },
    inventory_status: {
      issue: 'مشكلة',
      not_available: 'غير متوفر',
      deleted: 'تمت إزالته',
      withdrawn: 'مسحوب',
      delisted: 'تمت إزالته',
      ready: 'جاهز',
      listed: 'مسجل',
      listed_private: 'مسجل خاص',
      sold: 'تم البيع',
      withdraw_queue: 'طابور السحب',
      withdraw_pending: 'سحب معلق',
      instant_sell: 'بيع فوري',
    },
    service: {
      market: {
        buy: 'شراء',
        sell: 'بيع',
        fee: 'رسوم البيع',
        buy_order: 'أمر الشراء',
        bargain: 'تفاوض',
        instant_sell: 'بيع فوري',
        bump: 'رفع ',
        bump_package: 'رفع الرزمة',
      },
      deposit: {
        bitcoin: 'إيداع BTC',
        litecoin: 'إيداع LTC',
        ethereum: 'إيداع ETH',
        unlimint: 'إيداع باستخدام بطاقة البنك',
        zen: 'إيداع مع ZEN',
        gift_code: 'رمز الهدية',
        binancepay: 'إيداع باستخدام Binance Pay',
      },
      withdraw: {
        bitcoin: 'سحب BTC',
        litecoin: 'سحب LTC',
        ethereum: 'سحب ETH',
        unlimint: 'سحب إلى بطاقة فيزا',
        tipalti: 'سحب باستخدام Tipalti',
        payoneer: 'سحب باستخدام Payoneer',
        binancepay: 'سحب باستخدام Binance Pay',
        p2p: 'نقل نقطة لنقطة',
      },
      wallet: {
        transfer: 'تحويل الأموال',
        refund: 'استرداد الأموال',
      },
      marketing: {
        coupon: 'كوبون',
        referral: 'إحالة',
        affiliate: 'شريك تابع',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins تقدم منصة سلسة لشراء وبيع عناصر CS2 و DOTA2 و TF2 و RUST الخاصة بك. استكشف مجموعة واسعة من البنادق والسكاكين والقفازات وأكثر',
    home_title: 'BitSkins.com - شراء وبيع جلود CS2. تداول سريع وسهل وآمن',
    home_description: 'BitSkins تقدم منصة سلسة لشراء وبيع عناصر CS2 و DOTA2 و TF2 و RUST الخاصة بك. استكشف مجموعة واسعة من البنادق والسكاكين والقفازات وأكثر من ذلك. انضم الآن للتداول بسهولة!',
    support_title: 'دعم BitSkins: احصل على المساعدة لاحتياجات تداول CS2 الخاصة بك',
    support_description: 'تحتاج مساعدة في تداول CS2 الخاص بك؟ قم بزيارة صفحة دعم BitSkins للحصول على مساعدة سريعة. فريقنا هنا للتعامل مع استفساراتك، وحل المشاكل، وتقديم الإرشادات.',
    item_title: '{item} - {game} الجلود | ابحث وتداول العناصر المطلوبة في {game}',
    item_description_csgo: 'اكتشف وتداول الجلود المطلوبة للعبة CS2 على BitSkins. استكشف مجموعتنا الواسعة من البنادق والسكاكين والقفازات والمزيد. اشترِ، بيع، أو اسحب فوراً. ابدأ التصفح الآن!',
    item_description_cs2: 'اكتشف وتداول الجلود المطلوبة للعبة CS2 على BitSkins. استكشف مجموعتنا الواسعة من البنادق والسكاكين والقفازات والمزيد. اشترِ، بيع، أو اسحب فوراً. ابدأ التصفح الآن!',
    item_description_dota2: 'اكتشف وتداول الجلود المطلوبة لـ DOTA2 على BitSkins. استكشف مجموعتنا الواسعة من الأبراج والموسيقى والحزم والمزيد. اشترِ، بيع، أو اسحب فوراً. ابدأ التصفح الآن!',
    item_description_tf2: 'اكتشف وتداول العناصر المطلوبة الخاصة بك في لعبة TF2 على BitSkins. استكشف مجموعتنا الواسعة من الأدوات التجميلية والتحديات والصناديق والمزيد. قم بالشراء والبيع أو السحب فورًا. ابدأ التصفح الآن!',
    item_description_rust: 'اكتشف وتداول العناصر المطلوبة في لعبة راست على BitSkins. استكشف مجموعتنا الواسعة من الملابس والأسلحة والموارد وغيرها. قم بالشراء والبيع والسحب فورًا. ابدأ التصفح الآن!',
    market_title: 'سوق BitSkins: استكشف وتداول العناصر {game} بسهولة',
    market_description_csgo: 'ادخل إلى سوق BitSkins لاستكشاف وتداول مجموعة واسعة من عناصر CS2 بسهولة. اكتشف أفضل الصفقات على الجلود والمفاتيح والكبسولات وأكثر من ذلك. اشترِ، بيع، أو اسحب فورا.',
    market_description_cs2: 'ادخل إلى سوق BitSkins لاستكشاف وتداول مجموعة واسعة من عناصر CS2 بسهولة. اكتشف أفضل الصفقات على الجلود والمفاتيح والكبسولات وأكثر من ذلك. اشترِ، بيع، أو اسحب فورا.',
    market_description_dota2: 'ادخل إلى سوق BitSkins لاستكشاف وتداول مجموعة واسعة من عناصر DOTA2 بسهولة. اكتشف أفضل الصفقات على الأبراج والموسيقى والحزم وأكثر من ذلك. اشترِ، بيع، أو اسحب فورا.',
    market_description_tf2: 'ادخل إلى سوق BitSkins لاستكشاف وتداول مجموعة واسعة من عناصر TF2 بسهولة. اكتشف أفضل الصفقات على مستحضرات التجميل والتهكيرات والصناديق، وأكثر من ذلك. اشترِ، بيع، أو سحب فوراً.',
    market_description_rust: 'ادخل إلى سوق BitSkins لاستكشاف وتداول مجموعة واسعة من عناصر لعبة راست بكل سهولة. اكتشف أفضل الصفقات على الملابس والأسلحة والموارد وغيرها. قم بالشراء أو البيع أو السحب فورا.',
    market_item_title: 'سوق BitSkins: {skin} : سوق {game}',
    store_title: 'متجر مستخدم BitSkins: {alias} - عرض العناصر {game}',
    store_description: 'متجر مستخدمي BitSkins لعرض وبيع العناصر الخاصة بك. قم بتحديد أسعارك، وتفاعل مع المشترين، وأنشئ وجودك في مجتمع التداول.',
    login_title: 'تسجيل الدخول إلى BitSkins: وصول آمن إلى حساب التداول الخاص بك في CS2',
    login_description: 'سجل الدخول إلى حسابك في BitSkins بأمان. قم بالوصول إلى مخزون CS2 الخاص بك، وإدارة العناصر، وإجراء المعاملات، واستمتع بتجربة تداول سلسة.',
    steam_login_title: 'تسجيل الدخول باستخدام ستيم',
    profile_title: 'إعدادات حسابك',
    wallet_title: 'أموالك في BitSkins',
    affiliate_title: 'لوحة الشركاء في BitSkins: اكسب مكافآت عند الإحالة',
    affiliate_description: 'انضم إلى برنامج الشراكة في BitSkins واحصل على مكافآت عن طريق إحالة عشاق الجلود. استفد من برنامج شراكة مربح، وتتبع إحالاتك وزد من أرباحك.',
    statistics_title: 'إحصائيات مبيعات BitSkins: كشف اتجاهات السوق والرؤى',
    statistics_description: 'استكشف الإحصاءات الشاملة حول BitSkins للحصول على رؤى قيمة حول اتجاهات تداول CS2. قم بتحليل بيانات السوق وشعبية العناصر والمزيد لتحسين استراتيجيات التداول الخاصة بك.',
    sales_fees_title: 'رسوم بيع BitSkins: تسعير شفاف لمبيعات CS2 الخاصة بك',
    sales_fees_description: 'احصل على فهم واضح لهيكل رسوم بيع BitSkins. تضمن رسومنا الشفافة العدالة والبساطة لمبيعات CS2 الخاصة بك. تعرف على المزيد.',
    checkout_title: 'سلة BitSkins: إتمام الشراء المريح لعناصر CS2',
    checkout_description: 'تبسيط تجربة التداول في CS2 الخاصة بك مع عربة BitSkins. قم بإدارة عناصرك بسهولة، واستعرض طلبك، وانتقل إلى الدفع الآمن. استمتع بعملية تداول سلسة اليوم!',
    steam_inventory_title: 'مخزون ستيم {game}',
    bs_inventory_title: 'مخزون BitSkins {game}',
    selling_inventory_title: 'قائمة العناصر المدرجة {game}',
    buy_order_create_title: 'إنشاء أوامر الشراء لـ {game}',
    buy_order_active_title: 'أوامر الشراء النشطة لـ {game}',
    buy_order_title: 'أوامر الشراء لـ {game}',
    trades_active_title: 'الصفقات النشطة',
    trades_history_title: 'تاريخ التداولات',
    transactions_title: 'المعاملات',
    favorites_title: 'العناصر المفضلة',
    kyc_title: 'استمارة طلب معرفة العميل (KYC)',
    tos_title: 'شروط استخدام BitSkins: إرشادات لتداول آمن وموثوق به',
    tos_description: 'قم بمراجعة شروط الاستخدام الخاصة بنا للتداول الآمن والموثوق. اطلع على سياساتنا والتزاماتنا. قم بالتداول بأمان على BitSkins.',
    privacy_policy_title: 'سياسة الخصوصية لـ BitSkins: حماية معلوماتك الشخصية',
    privacy_policy_description: 'اقرأ سياسة الخصوصية لـ BitSkins لتتعرف على كيفية حماية ومعالجة معلوماتك الشخصية. الثقة والشفافية هما جوهر التزامنا.',
    cookie_policy_title: 'سياسة ملفات تعريف الارتباط لدى BitSkins: خصوصيتك تهمنا',
    cookie_policy_description: 'نحن في BitSkins نقدر خصوصيتك. اقرأ سياسة الكوكيز الخاصة بنا لفهم كيف نستخدم الكوكيز والتقنيات المماثلة. ثقتك وأمان بياناتك هما أولويتنا العليا.',
    docs_v1_title: 'واجهة برمجة التطبيقات الجديدة لـ V1 BitSkins: إصدار واجهة برمجة تطبيقات للإرث',
    docs_v1_description: 'قم بدمج واجهة برمجة تطبيقات BitSkins واجهة برمجة التطبيقات V1 للتداول السلس. قم بالوصول إلى الوثائق لتحسين قدرات التداول الخاصة بك. قم بالترقية إلى أحدث إصدار للحصول على ميزات جديدة.',
    docs_v2_title: 'واجهة برمجة التطبيقات الجديدة لـ BitSkins V2: أحدث إصدار لواجهة برمجة التطبيقات',
    docs_v2_description: 'فتح ميزات جديدة مع واجهة برمجة التطبيقات BitSkins V2. قم بتعزيز استراتيجيات التداول الخاصة بك وزيادة الكفاءة. استكشف وثائقنا الشاملة الآن!',
    docs_migration_title: 'واجهة برمجة التطبيقات الجديدة لـ BitSkins: انتقال سلس إلى واجهة برمجة التطبيقات الجديدة',
    docs_migration_description: 'انتقل بسهولة إلى واجهة برمجة التطبيقات الجديدة لـ BitSkins مع دليلنا الشامل. استكشف الميزات المحدثة وعمليات الدمج لتحسين تجربة التداول.',
  },
  alt: {
    envelope: 'ظرف',
    app_store: 'متجر التطبيقات',
    google_store: 'متجر جوجل',
  },
  time: {
    seconds: 'ثواني',
  },
  calendar: {
    week: 'أسبوع',
    month: 'شهر',
    lifetime: 'العمر',
  },
  docs: {
    docs: 'المستندات',
    api: 'واجهة برمجة التطبيقات',
    api_v1: 'واجهة برمجة التطبيقات V1 (البوابة)',
    api_v2: 'واجهة برمجة التطبيقات V2',
    api_migration_guide: 'دليل ترحيل واجهة برمجة التطبيقات',
    request_parameters: 'طلب المعلمات',
    sample_request: 'طلب عينة',
    sample_response: 'استجابة عينة',
    request_schema: 'مخطط الطلب',
    enums: 'ENUMS',
  },
  wallet: {
    coupon_redeemed: 'لقد استبدلت قسيمة بقيمة {amount}',
    balance_changed: 'تم تحديث الرصيد',
    transfer_p2p_confirm: 'تأكيد تحويل الأموال إلى p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'تحتاج إلى تأكيد التحويل',
    transfer_p2p_success: 'تم تحويل أموالك إلى p2p.bitskins.com',
    transfer_funds: 'نقل الأموال',
    deposit_started: 'بدأ الإيداع',
    card_removed: 'تمت إزالة البطاقة',
    confirm_card_remove: 'هل أنت متأكد أنك تريد إزالة هذه البطاقة؟',
    delete_card: 'حذف البطاقة',
    deposit: 'إيداع',
    withdraw: 'سحب',
    security_code: 'رمز الأمان',
    security_code_ccv: 'رمز الأمان',
    card_number: 'رقم البطاقة',
    full_name: 'الاسم الكامل',
    month_expired: 'شهر انتهت صلاحيته (MM/YYYY)',
    addr_line_1: 'عنوان الفوترة (السطر 1)',
    addr_line_2: 'عنوان الفوترة (السطر 2)',
    zip: 'الرمز البريدي أو البريد السريع',
    city: 'مدينة',
    country: 'البلد',
    withdraw_only_to_visa: 'يمكنك سحب الأموال فقط إلى بطاقة فيزا',
    card_country_is_restricted: 'نأسف، ولكننا لا نقدم سحب الأموال إلى البطاقات المصدرة في {country}',
  },
  twofa: {
    required: 'مصادقة ثنائية مطلوبة',
    required_for_this_payment_method: 'لا يمكنك استخدام طريقة الدفع هذه لأنك لم تقم بإعداد مصادقة ثنائية',
    you_can_start_now: 'يمكنك بدء عملية الإعداد الآن.',
    setup: 'إعداد 2FA',
    why_we_require: 'انقر للقراءة - لماذا نحتاج إلى 2FA لعمليات السحب؟',
  },
  password_strong: {
    minimum: 'يجب أن تحتوي كلمة المرور على {value} من الأحرف على الأقل',
    maximum: 'يجب أن تحتوي كلمة المرور على {value} من الأحرف على الأكثر',
    lowercase: 'يجب أن تحتوي كلمة المرور على حرف واحد صغير على الأقل',
    uppercase: 'يجب أن تحتوي كلمة المرور على حرف واحد كبير على الأقل',
    numeric: 'يجب أن تحتوي كلمة المرور على حرف رقمي واحد على الأقل',
    special: 'يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل',
  },
  help_center: {
    help_center: 'مركز المساعدة',
    hello: 'مرحبا، كيف يمكننا المساعدة؟',
    create_ticket: 'إنشاء تذكرة',
    contact_us: 'التواصل معنا',
    guide: 'دليل',
    top_articles: 'أهم المقالات',
    didnt_find: 'لم تجد ما تحتاجه؟',
    article: 'مقالات',
    general: 'عام',
    fees: 'مصاريف',
    buying_selling: 'بيع وشراء',
    deposit_withdrawal: 'الودائع والسحوبات',
    refunds: 'المبالغ المستردة',
    user_account: 'حساب المستخدم',
    affiliate: 'شريك تابع',
    partnership: 'شراكة',
    scam: 'عملية احتيال مشتبه بها',
    was_helpful: 'هل كانت هذه المادة مفيدة؟',
    found_helpful: '{yes} من بين {max} وجدوا ذلك مفيدا',
    faq: 'الأسئلة المطروحة <span class="color-primary">بشكل متكرر</span>',
  },
};
